import { SVGProps } from 'react';

export const DefaultSkillIcon = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="40"
      height="30"
    >
      <path d="m413.04,270.39l-76.14,19.17-12.1,12.1c-5.6,5.6-8.75,13.2-8.75,21.12v60c0,3.02,2.44,5.46,5.46,5.46h74.34c3.02,0,5.46-2.44,5.46-5.46h0c0-2.64,1.05-5.17,2.91-7.03l49.6-49.6c11.5-11.5,17.73-27.23,17.22-43.48l-3.83-122.9c-.44-14.15-12.04-25.39-26.2-25.39h0c-14.31,0-25.98,11.48-26.21,25.8l-1.75,110.2Z" />
      <path d="m410.56,285.33l-59.8,59.8-23.9-45.54,48.98-48.98c9.59-9.59,25.13-9.59,34.72,0h0c9.59,9.59,9.59,25.13,0,34.72Z" />
      <path
        className="cls-1"
        strokeWidth="1.6"
        d="m428.36,267.98c0,9.4-3.65,18.24-10.29,24.87l-37.14,37.14c-2.07,2.07-5.44,2.07-7.51,0-2.07-2.08-2.07-5.44,0-7.51l37.14-37.14c4.63-4.63,7.18-10.79,7.18-17.36s-2.55-12.73-7.18-17.36c-9.57-9.57-25.15-9.57-34.72,0-2.07,2.07-5.44,2.07-7.51,0-2.07-2.07-2.07-5.44,0-7.51,13.71-13.71,36.03-13.71,49.74,0,6.63,6.64,10.29,15.47,10.29,24.87Z"
      />
      <rect
        x="323.05"
        y="372.9"
        width="70.8"
        height="122.76"
        rx="2.29"
        ry="2.29"
        transform="translate(-75.83 792.73) rotate(-90)"
      />
      <circle
        className="cls-1"
        cx="326.86"
        cy="434.28"
        r="11.93"
      />
      <path d="m98.96,270.39l76.14,19.17,12.1,12.1c5.6,5.6,8.75,13.2,8.75,21.12v60c0,3.02-2.44,5.46-5.46,5.46h-74.34c-3.02,0-5.46-2.44-5.46-5.46h0c0-2.64-1.05-5.17-2.91-7.03l-49.6-49.6c-11.5-11.5-17.73-27.23-17.22-43.48l3.83-122.9c.44-14.15,12.04-25.39,26.2-25.39h0c14.31,0,25.98,11.48,26.21,25.8l1.75,110.2Z" />
      <path d="m101.44,285.33l59.8,59.8,23.9-45.54-48.98-48.98c-9.59-9.59-25.13-9.59-34.72,0h0c-9.59,9.59-9.59,25.13,0,34.72Z" />
      <path
        className="cls-1"
        d="m83.64,267.98c0,9.4,3.65,18.24,10.29,24.87l37.14,37.14c2.07,2.07,5.44,2.07,7.51,0,2.07-2.08,2.07-5.44,0-7.51l-37.14-37.14c-4.63-4.63-7.18-10.79-7.18-17.36s2.55-12.73,7.18-17.36c9.57-9.57,25.15-9.57,34.72,0,2.07,2.07,5.44,2.07,7.51,0,2.07-2.07,2.07-5.44,0-7.51-13.71-13.71-36.03-13.71-49.74,0-6.63,6.64-10.29,15.47-10.29,24.87Z"
      />
      <rect
        x="118.15"
        y="372.9"
        width="70.8"
        height="122.76"
        rx="2.29"
        ry="2.29"
        transform="translate(-280.73 587.83) rotate(-90)"
      />
      <circle
        className="cls-1"
        cx="185.14"
        cy="434.28"
        r="11.93"
      />
      <path d="m351.01,122.97h0c-12.35,0-18.54-14.93-9.8-23.67h0c4.35-4.35,4.35-11.4,0-15.74l-20.3-20.3c-4.35-4.35-11.4-4.35-15.74,0h0c-8.73,8.73-23.67,2.55-23.67-9.8h0c0-6.15-4.98-11.13-11.13-11.13h-28.71c-6.15,0-11.13,4.98-11.13,11.13h0c0,12.35-14.93,18.54-23.67,9.8h0c-4.35-4.35-11.4-4.35-15.74,0l-20.3,20.3c-4.35,4.35-4.35,11.4,0,15.74h0c8.73,8.73,2.55,23.67-9.8,23.67h0c-6.15,0-11.13,4.98-11.13,11.13v28.71c0,6.15,4.98,11.13,11.13,11.13h0c12.35,0,18.54,14.93,9.8,23.67h0c-4.35,4.35-4.35,11.4,0,15.74l20.3,20.3c4.35,4.35,11.4,4.35,15.74,0h0c8.73-8.73,23.67-2.55,23.67,9.8h0c0,6.15,4.98,11.13,11.13,11.13h28.71c6.15,0,11.13-4.98,11.13-11.13h0c0-12.35,14.93-18.54,23.67-9.8h0c4.35,4.35,11.4,4.35,15.74,0l20.3-20.3c4.35-4.35,4.35-11.4,0-15.74h0c-8.73-8.73-2.55-23.67,9.8-23.67h0c6.15,0,11.13-4.98,11.13-11.13v-28.71c0-6.15-4.98-11.13-11.13-11.13Z" />
      <circle
        className="cls-1"
        cx="256"
        cy="148.46"
        r="52.91"
      />
    </svg>
  );
};

export const ClockGrayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9 4.2V8.25L11.7 9.6M15.75 8.25C15.75 11.9779 12.7279 15 9 15C5.27208 15 2.25 11.9779 2.25 8.25C2.25 4.52208 5.27208 1.5 9 1.5C12.7279 1.5 15.75 4.52208 15.75 8.25Z"
        stroke="#9E9E9E"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DropDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke="#5C5A5A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TaskIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.16683 6.06221H13.3335M9.16683 9.58073H13.3335M9.16683 13.0992H13.3335M8.3335 1.66406H4.5835C3.8935 1.66406 3.3335 2.25517 3.3335 2.98351V16.178C3.3335 16.9063 3.8935 17.4974 4.5835 17.4974H15.4168C16.1068 17.4974 16.6668 16.9063 16.6668 16.178V2.98351C16.6668 2.25517 16.1068 1.66406 15.4168 1.66406H8.3335ZM6.66683 6.06221H6.67572V6.07159H6.66683V6.06221ZM6.66683 9.58073H6.67572V9.59011H6.66683V9.58073ZM6.66683 13.0992H6.67572V13.1086H6.66683V13.0992Z"
        stroke="#111927"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClipBoardDocIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 7.5V6.10822C8.25 4.97324 9.09499 4.01015 10.2261 3.91627C10.5994 3.88529 10.9739 3.85858 11.3495 3.83619M15.75 18H18C19.2426 18 20.25 16.9926 20.25 15.75V6.10822C20.25 4.97324 19.405 4.01015 18.2739 3.91627C17.9006 3.88529 17.5261 3.85858 17.1505 3.83619M15.75 18.75V16.875C15.75 15.011 14.239 13.5 12.375 13.5H10.875C10.2537 13.5 9.75 12.9963 9.75 12.375V10.875C9.75 9.01104 8.23896 7.5 6.375 7.5H5.25M17.1505 3.83619C16.8672 2.91757 16.0116 2.25 15 2.25H13.5C12.4884 2.25 11.6328 2.91757 11.3495 3.83619M17.1505 3.83619C17.2152 4.04602 17.25 4.26894 17.25 4.5V5.25H11.25V4.5C11.25 4.26894 11.2848 4.04602 11.3495 3.83619M6.75 7.5H4.875C4.25368 7.5 3.75 8.00368 3.75 8.625V20.625C3.75 21.2463 4.25368 21.75 4.875 21.75H14.625C15.2463 21.75 15.75 21.2463 15.75 20.625V16.5C15.75 11.5294 11.7206 7.5 6.75 7.5Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GoalsIcon = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.86866 14.4599L4 21L8.5884 18.247C8.73805 18.1572 8.81288 18.1123 8.89276 18.0947C8.96341 18.0792 9.03659 18.0792 9.10724 18.0947C9.18712 18.1123 9.26195 18.1572 9.4116 18.247L14 21L13.1319 14.4571M13.4259 3.24888C13.5803 3.6224 13.8768 3.9193 14.25 4.0743L15.5589 4.61648C15.9325 4.77121 16.2292 5.06799 16.384 5.44154C16.5387 5.81509 16.5387 6.23481 16.384 6.60836L15.8422 7.91635C15.6874 8.29007 15.6872 8.71021 15.8427 9.08374L16.3835 10.3913C16.4602 10.5764 16.4997 10.7747 16.4997 10.975C16.4998 11.1752 16.4603 11.3736 16.3837 11.5586C16.3071 11.7436 16.1947 11.9118 16.0531 12.0534C15.9114 12.195 15.7433 12.3073 15.5582 12.3839L14.2503 12.9256C13.8768 13.0801 13.5799 13.3765 13.4249 13.7498L12.8827 15.0588C12.728 15.4323 12.4312 15.7291 12.0577 15.8838C11.6841 16.0386 11.2644 16.0386 10.8909 15.8838L9.58296 15.342C9.20942 15.1877 8.78987 15.188 8.41656 15.3429L7.10767 15.8843C6.73434 16.0387 6.31501 16.0386 5.94178 15.884C5.56854 15.7293 5.27194 15.4329 5.11711 15.0598L4.57479 13.7504C4.42035 13.3769 4.12391 13.08 3.75064 12.925L2.44175 12.3828C2.06838 12.2282 1.77169 11.9316 1.61691 11.5582C1.46213 11.1849 1.46192 10.7654 1.61633 10.3919L2.1581 9.08391C2.31244 8.71035 2.31213 8.29079 2.15722 7.91746L1.61623 6.60759C1.53953 6.42257 1.50003 6.22426 1.5 6.02397C1.49997 5.82369 1.5394 5.62536 1.61604 5.44032C1.69268 5.25529 1.80504 5.08716 1.94668 4.94556C2.08832 4.80396 2.25647 4.69166 2.44152 4.61508L3.74947 4.07329C4.12265 3.91898 4.41936 3.6229 4.57448 3.25004L5.11664 1.94111C5.27136 1.56756 5.56813 1.27078 5.94167 1.11605C6.3152 0.961318 6.7349 0.961318 7.10844 1.11605L8.41638 1.65784C8.78993 1.81218 9.20948 1.81187 9.58279 1.65696L10.8922 1.11689C11.2657 0.962245 11.6853 0.962277 12.0588 1.11697C12.4322 1.27167 12.729 1.56837 12.8837 1.94182L13.426 3.25115L13.4259 3.24888Z"
        stroke="#384250"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserGroupIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0002 18.7191C18.2477 18.7396 18.498 18.75 18.7508 18.75C19.7992 18.75 20.8056 18.5708 21.7413 18.2413C21.7476 18.1617 21.7508 18.0812 21.7508 18C21.7508 16.3431 20.4077 15 18.7508 15C18.1232 15 17.5406 15.1927 17.059 15.5222M18.0002 18.7191C18.0002 18.7294 18.0002 18.7397 18.0002 18.75C18.0002 18.975 17.9879 19.1971 17.9637 19.4156C16.207 20.4237 14.1709 21 12.0002 21C9.82957 21 7.79352 20.4237 6.03675 19.4156C6.01263 19.1971 6.00024 18.975 6.00024 18.75C6.00024 18.7397 6.00027 18.7295 6.00032 18.7192M18.0002 18.7191C17.9943 17.5426 17.6497 16.4461 17.059 15.5222M17.059 15.5222C15.9931 13.8552 14.1257 12.75 12.0002 12.75C9.87504 12.75 8.0079 13.8549 6.94193 15.5216M6.94193 15.5216C6.46047 15.1925 5.8782 15 5.25098 15C3.59412 15 2.25098 16.3431 2.25098 18C2.25098 18.0812 2.2542 18.1617 2.26054 18.2413C3.19617 18.5708 4.20264 18.75 5.25098 18.75C5.50332 18.75 5.75323 18.7396 6.00032 18.7192M6.94193 15.5216C6.35095 16.4457 6.00623 17.5424 6.00032 18.7192M15.0002 6.75C15.0002 8.40685 13.6571 9.75 12.0002 9.75C10.3434 9.75 9.00024 8.40685 9.00024 6.75C9.00024 5.09315 10.3434 3.75 12.0002 3.75C13.6571 3.75 15.0002 5.09315 15.0002 6.75ZM21.0002 9.75C21.0002 10.9926 19.9929 12 18.7502 12C17.5076 12 16.5002 10.9926 16.5002 9.75C16.5002 8.50736 17.5076 7.5 18.7502 7.5C19.9929 7.5 21.0002 8.50736 21.0002 9.75ZM7.50024 9.75C7.50024 10.9926 6.49288 12 5.25024 12C4.0076 12 3.00024 10.9926 3.00024 9.75C3.00024 8.50736 4.0076 7.5 5.25024 7.5C6.49288 7.5 7.50024 8.50736 7.50024 9.75Z"
        stroke="#222222"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowSeparatorIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 13.7L16.95 11L14.25 8.3M9.75 8.3L7.05 11L9.75 13.7M21 11C21 15.9706 16.9706 20 12 20C7.02944 20 3 15.9706 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z"
        stroke="#384250"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DateRangerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11H7V13H9V11ZM13 11H11V13H13V11ZM17 11H15V13H17V11ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z"
        fill="#384250"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
        fill="#6366F1"
      />
      <path
        d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
        fill="#6366F1"
      />
    </svg>
  );
};

export const ClockInIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M12.49 2C6.97 2 2.5 6.48 2.5 12C2.5 17.52 6.97 22 12.49 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.49 2ZM12.5 20C8.08 20 4.5 16.42 4.5 12C4.5 7.58 8.08 4 12.5 4C16.92 4 20.5 7.58 20.5 12C20.5 16.42 16.92 20 12.5 20Z"
        fill="white"
      />
      <path
        d="M13 7H11.5V13L16.75 16.15L17.5 14.92L13 12.25V7Z"
        fill="white"
      />
    </svg>
  );
};

export const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M5 6.75L9.5 11.25L14 6.75"
        stroke="#BDBDBD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M10.658 1.66406C6.05801 1.66406 2.33301 5.3974 2.33301 9.9974C2.33301 14.5974 6.05801 18.3307 10.658 18.3307C15.2663 18.3307 18.9997 14.5974 18.9997 9.9974C18.9997 5.3974 15.2663 1.66406 10.658 1.66406ZM10.6663 16.6641C6.98301 16.6641 3.99967 13.6807 3.99967 9.9974C3.99967 6.31406 6.98301 3.33073 10.6663 3.33073C14.3497 3.33073 17.333 6.31406 17.333 9.9974C17.333 13.6807 14.3497 16.6641 10.6663 16.6641Z"
        fill="#384250"
      />
      <path
        d="M11.083 5.83073H9.83301V10.8307L14.208 13.4557L14.833 12.4307L11.083 10.2057V5.83073Z"
        fill="#384250"
      />
    </svg>
  );
};

export const PrintIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.0003 5.83366V4.33366C15.0003 3.40024 15.0003 2.93353 14.8187 2.57701C14.6589 2.2634 14.4039 2.00844 14.0903 1.84865C13.7338 1.66699 13.2671 1.66699 12.3337 1.66699H7.66699C6.73357 1.66699 6.26686 1.66699 5.91034 1.84865C5.59674 2.00844 5.34177 2.2634 5.18198 2.57701C5.00033 2.93353 5.00033 3.40024 5.00033 4.33366V5.83366M5.00033 15.0003C4.22535 15.0003 3.83786 15.0003 3.51994 14.9151C2.65721 14.684 1.98335 14.0101 1.75218 13.1474C1.66699 12.8295 1.66699 12.442 1.66699 11.667V9.83366C1.66699 8.43353 1.66699 7.73346 1.93948 7.19868C2.17916 6.72828 2.56161 6.34583 3.03202 6.10614C3.5668 5.83366 4.26686 5.83366 5.66699 5.83366H14.3337C15.7338 5.83366 16.4339 5.83366 16.9686 6.10614C17.439 6.34583 17.8215 6.72828 18.0612 7.19868C18.3337 7.73346 18.3337 8.43353 18.3337 9.83366V11.667C18.3337 12.442 18.3337 12.8295 18.2485 13.1474C18.0173 14.0101 17.3434 14.684 16.4807 14.9151C16.1628 15.0003 15.7753 15.0003 15.0003 15.0003M12.5003 8.75033H15.0003M7.66699 18.3337H12.3337C13.2671 18.3337 13.7338 18.3337 14.0903 18.152C14.4039 17.9922 14.6589 17.7372 14.8187 17.4236C15.0003 17.0671 15.0003 16.6004 15.0003 15.667V14.3337C15.0003 13.4002 15.0003 12.9335 14.8187 12.577C14.6589 12.2634 14.4039 12.0084 14.0903 11.8486C13.7338 11.667 13.2671 11.667 12.3337 11.667H7.66699C6.73357 11.667 6.26686 11.667 5.91034 11.8486C5.59674 12.0084 5.34177 12.2634 5.18198 12.577C5.00033 12.9335 5.00033 13.4002 5.00033 14.3337V15.667C5.00033 16.6004 5.00033 17.0671 5.18198 17.4236C5.34177 17.7372 5.59674 17.9922 5.91034 18.152C6.26686 18.3337 6.73357 18.3337 7.66699 18.3337Z"
        stroke="#6C737F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.1663 5.83301L5.83301 14.1663M5.83301 5.83301L14.1663 14.1663"
        stroke="#6C737F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EOCOpenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66667 10H13.3333M6.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5Z"
        stroke="#B42318"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIconColor = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 12.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V12.5M14.1667 8.33333L10 12.5M10 12.5L5.83333 8.33333M10 12.5V2.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M14.201 7.60104C14.533 7.2691 14.533 6.7309 14.201 6.39896L8.79167 0.989592C8.45973 0.657647 7.92154 0.657647 7.58959 0.989592C7.25765 1.32154 7.25765 1.85973 7.58959 2.19167L12.3979 7L7.58959 11.8083C7.25765 12.1403 7.25765 12.6785 7.58959 13.0104C7.92154 13.3424 8.45973 13.3424 8.79167 13.0104L14.201 7.60104ZM0 7.85H13.6V6.15H0V7.85Z"
        fill="#111927"
        fill-opacity="0.38"
      />
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M19.25 9.16634H2.75M14.6667 1.83301V5.49967M7.33333 1.83301V5.49967M7.15 20.1663H14.85C16.3901 20.1663 17.1602 20.1663 17.7485 19.8666C18.2659 19.603 18.6866 19.1823 18.9503 18.6648C19.25 18.0766 19.25 17.3065 19.25 15.7663V8.06634C19.25 6.5262 19.25 5.75612 18.9503 5.16787C18.6866 4.65042 18.2659 4.22972 17.7485 3.96607C17.1602 3.66634 16.3901 3.66634 14.85 3.66634H7.15C5.60986 3.66634 4.83978 3.66634 4.25153 3.96607C3.73408 4.22972 3.31338 4.65042 3.04973 5.16787C2.75 5.75612 2.75 6.5262 2.75 8.06634V15.7663C2.75 17.3065 2.75 18.0766 3.04973 18.6648C3.31338 19.1823 3.73408 19.603 4.25153 19.8666C4.83978 20.1663 5.60986 20.1663 7.15 20.1663Z"
        stroke="#6C737F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RSSkillDrawerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={35}
      height={35}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="20"
        height="20"
        rx="3.31081"
        fill="#F04C58"
      />
      <path
        d="M7.51007 13.6573L5.86656 10.7544H5.1622V13.6573H3.66809V6.20801H6.4642C7.0405 6.20801 7.53142 6.31117 7.93696 6.51751C8.3425 6.71672 8.64488 6.99065 8.8441 7.33928C9.05042 7.6808 9.15359 8.065 9.15359 8.4919C9.15359 8.98283 9.01129 9.42751 8.7267 9.82595C8.44211 10.2173 8.01878 10.4876 7.45671 10.637L9.23897 13.6573H7.51007ZM5.1622 9.63384H6.41084C6.81638 9.63384 7.11876 9.53779 7.31797 9.34569C7.51719 9.14647 7.61679 8.87255 7.61679 8.52392C7.61679 8.1824 7.51719 7.91915 7.31797 7.73416C7.11876 7.54206 6.81638 7.446 6.41084 7.446H5.1622V9.63384Z"
        fill="white"
      />
      <path
        d="M12.6846 13.8059C12.1674 13.8059 11.6999 13.7173 11.2819 13.5402C10.871 13.3631 10.5451 13.1081 10.3043 12.7751C10.0634 12.4421 9.93946 12.049 9.93237 11.5956H11.5263C11.5476 11.9002 11.6538 12.1411 11.8451 12.3182C12.0434 12.4953 12.3126 12.5838 12.6527 12.5838C12.9998 12.5838 13.2725 12.5024 13.4709 12.3394C13.6692 12.1694 13.7684 11.9498 13.7684 11.6806C13.7684 11.461 13.7011 11.2803 13.5665 11.1386C13.4319 10.997 13.2619 10.8872 13.0565 10.8092C12.8581 10.7242 12.5818 10.6321 12.2276 10.5329C11.7459 10.3913 11.3527 10.2531 11.0481 10.1185C10.7506 9.97683 10.492 9.76784 10.2724 9.49156C10.0599 9.20819 9.95363 8.83272 9.95363 8.36516C9.95363 7.92594 10.0634 7.54339 10.283 7.21751C10.5026 6.89164 10.8108 6.64369 11.2075 6.47367C11.6042 6.29656 12.0576 6.20801 12.5677 6.20801C13.3327 6.20801 13.9526 6.39574 14.4272 6.77121C14.909 7.13959 15.1746 7.65674 15.2242 8.32266H13.5878C13.5736 8.06762 13.4638 7.85864 13.2584 7.6957C13.06 7.52568 12.7944 7.44067 12.4614 7.44067C12.171 7.44067 11.9372 7.51505 11.7601 7.66382C11.5901 7.81259 11.505 8.02866 11.505 8.31203C11.505 8.51039 11.5688 8.67687 11.6963 8.81147C11.8309 8.93899 11.9938 9.04525 12.1851 9.13026C12.3835 9.20819 12.6598 9.30028 13.014 9.40655C13.4957 9.54823 13.8888 9.68992 14.1935 9.8316C14.4981 9.97329 14.7602 10.1858 14.9798 10.4692C15.1994 10.7526 15.3092 11.1245 15.3092 11.585C15.3092 11.9817 15.2065 12.3501 15.0011 12.6901C14.7956 13.0301 14.4945 13.3029 14.0978 13.5083C13.7011 13.7067 13.23 13.8059 12.6846 13.8059Z"
        fill="white"
      />
      <ellipse
        cx="17.0167"
        cy="12.8297"
        rx="0.827703"
        ry="0.827703"
        fill="#76CE82"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M6.19688 11.9038L3.41688 8.77625L2.47021 9.83375L6.19688 14.0263L14.1969 5.02625L13.2569 3.96875L6.19688 11.9038Z"
        fill="#107569"
      />
    </svg>
  );
};

export const LaborLocationTypeIcons = ({ iconType, style }: any) => {
  switch (iconType) {
    case 'BUILDING':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          style={style}
        >
          <path
            d="M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13"
            stroke="#6C737F"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'DRIVE':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style={style}
          fill="none"
        >
          <path
            d="M5 13H8M2 9L4 10L5.27064 6.18807C5.53292 5.40125 5.66405 5.00784 5.90729 4.71698C6.12208 4.46013 6.39792 4.26132 6.70951 4.13878C7.06236 4 7.47705 4 8.30643 4H15.6936C16.523 4 16.9376 4 17.2905 4.13878C17.6021 4.26132 17.8779 4.46013 18.0927 4.71698C18.3359 5.00784 18.4671 5.40125 18.7294 6.18807L20 10L22 9M16 13H19M6.8 10H17.2C18.8802 10 19.7202 10 20.362 10.327C20.9265 10.6146 21.3854 11.0735 21.673 11.638C22 12.2798 22 13.1198 22 14.8V17.5C22 17.9647 22 18.197 21.9616 18.3902C21.8038 19.1836 21.1836 19.8038 20.3902 19.9616C20.197 20 19.9647 20 19.5 20H19C17.8954 20 17 19.1046 17 18C17 17.7239 16.7761 17.5 16.5 17.5H7.5C7.22386 17.5 7 17.7239 7 18C7 19.1046 6.10457 20 5 20H4.5C4.03534 20 3.80302 20 3.60982 19.9616C2.81644 19.8038 2.19624 19.1836 2.03843 18.3902C2 18.197 2 17.9647 2 17.5V14.8C2 13.1198 2 12.2798 2.32698 11.638C2.6146 11.0735 3.07354 10.6146 3.63803 10.327C4.27976 10 5.11984 10 6.8 10Z"
            stroke="#6C737F"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'MILEAGE':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          style={{ marginRight: '10px', position: 'relative', top: '4px' }}
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M5 13H8M2 9L4 10L5.27064 6.18807C5.53292 5.40125 5.66405 5.00784 5.90729 4.71698C6.12208 4.46013 6.39792 4.26132 6.70951 4.13878C7.06236 4 7.47705 4 8.30643 4H15.6936C16.523 4 16.9376 4 17.2905 4.13878C17.6021 4.26132 17.8779 4.46013 18.0927 4.71698C18.3359 5.00784 18.4671 5.40125 18.7294 6.18807L20 10L22 9M16 13H19M6.8 10H17.2C18.8802 10 19.7202 10 20.362 10.327C20.9265 10.6146 21.3854 11.0735 21.673 11.638C22 12.2798 22 13.1198 22 14.8V17.5C22 17.9647 22 18.197 21.9616 18.3902C21.8038 19.1836 21.1836 19.8038 20.3902 19.9616C20.197 20 19.9647 20 19.5 20H19C17.8954 20 17 19.1046 17 18C17 17.7239 16.7761 17.5 16.5 17.5H7.5C7.22386 17.5 7 17.7239 7 18C7 19.1046 6.10457 20 5 20H4.5C4.03534 20 3.80302 20 3.60982 19.9616C2.81644 19.8038 2.19624 19.1836 2.03843 18.3902C2 18.197 2 17.9647 2 17.5V14.8C2 13.1198 2 12.2798 2.32698 11.638C2.6146 11.0735 3.07354 10.6146 3.63803 10.327C4.27976 10 5.11984 10 6.8 10Z"
            stroke="#6C737F"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};

export const IconTask = ({ iconType }: any) => {
  let icon;
  switch (iconType) {
    case 'EVALUATION':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.125 2.5V11.875C3.125 12.3723 3.32254 12.8492 3.67417 13.2008C4.02581 13.5525 4.50272 13.75 5 13.75H6.875M3.125 2.5H1.875M3.125 2.5H16.875M6.875 13.75H13.125M6.875 13.75L6.04167 16.25M16.875 2.5H18.125M16.875 2.5V11.875C16.875 12.3723 16.6775 12.8492 16.3258 13.2008C15.9742 13.5525 15.4973 13.75 15 13.75H13.125M13.125 13.75L13.9583 16.25M6.04167 16.25H13.9583M6.04167 16.25L5.625 17.5M13.9583 16.25L14.375 17.5M6.25 10L8.75 7.5L10.54 9.29C11.381 8.08275 12.4768 7.07485 13.75 6.3375"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'THERAPY':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M13.055 3.24C12.9439 2.84692 12.7075 2.50087 12.3816 2.25449C12.0558 2.0081 11.6585 1.87485 11.25 1.875H8.75C7.89167 1.875 7.16667 2.4525 6.945 3.24M13.055 3.24C13.1008 3.40167 13.125 3.57333 13.125 3.75C13.125 3.91576 13.0592 4.07473 12.9419 4.19194C12.8247 4.30915 12.6658 4.375 12.5 4.375H7.5C7.33424 4.375 7.17527 4.30915 7.05806 4.19194C6.94085 4.07473 6.875 3.91576 6.875 3.75C6.875 3.57333 6.9 3.40167 6.945 3.24M13.055 3.24C13.5933 3.28083 14.1283 3.33167 14.6608 3.39333C15.5775 3.5 16.25 4.29083 16.25 5.21417V16.25C16.25 16.7473 16.0525 17.2242 15.7008 17.5758C15.3492 17.9275 14.8723 18.125 14.375 18.125H5.625C5.12772 18.125 4.65081 17.9275 4.29917 17.5758C3.94754 17.2242 3.75 16.7473 3.75 16.25V5.21417C3.75 4.29083 4.42167 3.5 5.33917 3.39333C5.87336 3.33148 6.40875 3.28036 6.945 3.24"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.08337 11.2526H12.9167M10 8.33594V14.1693"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'GROUP_THERAPY':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14.481 12.837C14.8708 12.5708 15.0628 12.5176 15.5346 12.5004C16.0063 12.4832 16.4733 12.5999 16.8815 12.837C17.2896 13.0741 17.6223 13.422 17.8411 13.8403C18.0598 14.2586 18.1556 14.7303 18.1174 15.2008C17.1176 15.5503 16.0556 15.6863 14.9999 15.6C14.9967 14.6555 14.8081 13.2974 14.2991 12.5018C13.8474 11.7933 13.1409 11.0184 12.404 10.6146C11.6671 10.2108 10.8402 9.99943 9.99995 10C9.15981 9.99957 8.33314 10.211 7.59639 10.6148C6.85964 11.0186 6.15244 11.7934 5.70077 12.5018M14.9991 15.5992L14.9999 15.625C14.9999 15.8125 14.9899 15.9975 14.9691 16.18C13.4569 17.0476 11.7434 17.5028 9.99995 17.5C8.19161 17.5 6.49411 17.02 5.03078 16.18C5.00936 15.9871 4.99906 15.7932 4.99995 15.5992M4.99995 15.5992C3.94464 15.6886 2.8832 15.5531 1.88411 15.2017C1.84607 14.7313 1.94194 14.2598 2.16064 13.8416C2.37933 13.4234 2.71192 13.0757 3.11995 12.8386C3.52798 12.6015 3.99478 12.4847 4.46638 12.5018C4.93798 12.5188 5.41642 12.837 5.70077 12.5018M4.99995 15.5992C5.00294 14.6548 5.19213 13.2975 5.70077 12.5018M12.4999 5.625C12.4999 6.28804 12.2366 6.92393 11.7677 7.39277C11.2989 7.86161 10.663 8.125 9.99995 8.125C9.33691 8.125 8.70102 7.86161 8.23218 7.39277C7.76334 6.92393 7.49995 6.28804 7.49995 5.625C7.49995 4.96196 7.76334 4.32607 8.23218 3.85723C8.70102 3.38839 9.33691 3.125 9.99995 3.125C10.663 3.125 11.2989 3.38839 11.7677 3.85723C12.2366 4.32607 12.4999 4.96196 12.4999 5.625ZM17.4999 8.125C17.4999 8.37123 17.4514 8.61505 17.3572 8.84253C17.263 9.07002 17.1249 9.27672 16.9508 9.45082C16.7767 9.62493 16.57 9.76305 16.3425 9.85727C16.115 9.9515 15.8712 10 15.6249 10C15.3787 10 15.1349 9.9515 14.9074 9.85727C14.6799 9.76305 14.4732 9.62493 14.2991 9.45082C14.125 9.27672 13.9869 9.07002 13.8927 8.84253C13.7984 8.61505 13.7499 8.37123 13.7499 8.125C13.7499 7.62772 13.9475 7.15081 14.2991 6.79917C14.6508 6.44754 15.1277 6.25 15.6249 6.25C16.1222 6.25 16.5991 6.44754 16.9508 6.79917C17.3024 7.15081 17.4999 7.62772 17.4999 8.125ZM6.24995 8.125C6.24995 8.37123 6.20145 8.61505 6.10722 8.84253C6.01299 9.07002 5.87488 9.27672 5.70077 9.45082C5.52666 9.62493 5.31996 9.76305 5.09248 9.85727C4.86499 9.9515 4.62118 10 4.37495 10C4.12872 10 3.8849 9.9515 3.65742 9.85727C3.42993 9.76305 3.22323 9.62493 3.04912 9.45082C2.87501 9.27672 2.7369 9.07002 2.64267 8.84253C2.54845 8.61505 2.49995 8.37123 2.49995 8.125C2.49995 7.62772 2.69749 7.15081 3.04912 6.79917C3.40075 6.44754 3.87767 6.25 4.37495 6.25C4.87223 6.25 5.34914 6.44754 5.70077 6.79917C6.0524 7.15081 6.24995 7.62772 6.24995 8.125Z"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 13.3307H12M10 11.6641V14.9974"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'INSURANCE_CALL':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M1.875 5.625C1.875 12.5283 7.47167 18.125 14.375 18.125H16.25C16.7473 18.125 17.2242 17.9275 17.5758 17.5758C17.9275 17.2242 18.125 16.7473 18.125 16.25V15.1067C18.125 14.6767 17.8325 14.3017 17.415 14.1975L13.7292 13.2758C13.3625 13.1842 12.9775 13.3217 12.7517 13.6233L11.9433 14.7008C11.7083 15.0142 11.3025 15.1525 10.935 15.0175C9.57073 14.5159 8.33179 13.7238 7.30398 12.696C6.27618 11.6682 5.48406 10.4293 4.9825 9.065C4.8475 8.6975 4.98583 8.29167 5.29917 8.05667L6.37667 7.24833C6.67917 7.0225 6.81583 6.63667 6.72417 6.27083L5.8025 2.585C5.75178 2.38225 5.63477 2.20225 5.47004 2.07361C5.30532 1.94498 5.10234 1.87507 4.89333 1.875H3.75C3.25272 1.875 2.77581 2.07254 2.42417 2.42417C2.07254 2.77581 1.875 3.25272 1.875 3.75V5.625Z"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'SCREENINGS':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.16671 6.06221H13.3334M9.16671 9.58073H13.3334M9.16671 13.0992H13.3334M8.33337 1.66406H4.58337C3.89337 1.66406 3.33337 2.25517 3.33337 2.98351V16.178C3.33337 16.9063 3.89337 17.4974 4.58337 17.4974H15.4167C16.1067 17.4974 16.6667 16.9063 16.6667 16.178V2.98351C16.6667 2.25517 16.1067 1.66406 15.4167 1.66406H8.33337ZM6.66671 6.06221H6.6756V6.07159H6.66671V6.06221ZM6.66671 9.58073H6.6756V9.59011H6.66671V9.58073ZM6.66671 13.0992H6.6756V13.1086H6.66671V13.0992Z"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 15 16"
          fill="none"
        >
          <path
            d="M10.4811 10.712C10.8709 10.4458 11.0629 10.3926 11.5347 10.3754C12.0064 10.3582 12.4734 10.4749 12.8816 10.712C13.2897 10.9491 13.6224 11.297 13.8412 11.7153C14.0599 12.1336 14.1557 12.6053 14.1176 13.0758C13.1177 13.4253 12.0557 13.5613 11.0001 13.475C10.9968 12.5305 10.8082 11.1724 10.2992 10.3768C9.84748 9.66826 9.14098 8.89336 8.40408 8.48959C7.66717 8.08581 6.84033 7.87443 6.00005 7.875C5.15992 7.87457 4.33324 8.08602 3.59649 8.48979C2.85975 8.89356 2.15255 9.66838 1.70088 10.3768C1.19223 11.1725 1.00305 12.5298 1.00005 13.4742C0.999166 13.6682 1.00946 13.8621 1.03089 14.055C2.49422 14.895 4.19172 15.375 6.00005 15.375C7.74346 15.3778 9.45702 14.9226 10.9692 14.055C10.9901 13.8725 11.0001 13.6875 11.0001 13.5L10.9992 13.4742M8.50005 3.5C8.50005 4.16304 8.23666 4.79893 7.76782 5.26777C7.29898 5.73661 6.66309 6 6.00005 6C5.33701 6 4.70113 5.73661 4.23229 5.26777C3.76344 4.79893 3.50005 4.16304 3.50005 3.5C3.50005 2.83696 3.76344 2.20107 4.23229 1.73223C4.70113 1.26339 5.33701 1 6.00005 1C6.66309 1 7.29898 1.26339 7.76782 1.73223C8.23666 2.20107 8.50005 2.83696 8.50005 3.5ZM13.5001 6C13.5001 6.24623 13.4516 6.49005 13.3573 6.71753C13.2631 6.94502 13.125 7.15171 12.9509 7.32582C12.7768 7.49993 12.5701 7.63805 12.3426 7.73227C12.1151 7.8265 11.8713 7.875 11.6251 7.875C11.3788 7.875 11.135 7.8265 10.9075 7.73227C10.68 7.63805 10.4733 7.49993 10.2992 7.32582C10.1251 7.15171 9.98701 6.94502 9.89278 6.71753C9.79855 6.49005 9.75005 6.24623 9.75005 6C9.75005 5.50272 9.9476 5.02581 10.2992 4.67417C10.6509 4.32254 11.1278 4.125 11.6251 4.125C12.1223 4.125 12.5992 4.32254 12.9509 4.67417C13.3025 5.02581 13.5001 5.50272 13.5001 6Z"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 11.75H7.5M6 10.5V13"
            stroke="#111927"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};

export const TaskOverviewIcons = ({ iconType }: any) => {
  switch (iconType) {
    case 'Individual therapy':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="18"
          viewBox="0 0 16 18"
          fill="none"
        >
          <path
            d="M9.7495 2.916C9.6495 2.56223 9.43671 2.25079 9.14348 2.02904C8.85026 1.80729 8.49263 1.68736 8.125 1.6875H5.875C5.1025 1.6875 4.45 2.20725 4.2505 2.916M9.7495 2.916C9.79075 3.0615 9.8125 3.216 9.8125 3.375C9.8125 3.52418 9.75324 3.66726 9.64775 3.77275C9.54226 3.87824 9.39918 3.9375 9.25 3.9375H4.75C4.60082 3.9375 4.45774 3.87824 4.35225 3.77275C4.24676 3.66726 4.1875 3.52418 4.1875 3.375C4.1875 3.216 4.21 3.0615 4.2505 2.916M9.7495 2.916C10.234 2.95275 10.7155 2.9985 11.1948 3.054C12.0198 3.15 12.625 3.86175 12.625 4.69275V14.625C12.625 15.0726 12.4472 15.5018 12.1307 15.8182C11.8143 16.1347 11.3851 16.3125 10.9375 16.3125H3.0625C2.61495 16.3125 2.18573 16.1347 1.86926 15.8182C1.55279 15.5018 1.375 15.0726 1.375 14.625V4.69275C1.375 3.86175 1.9795 3.15 2.80525 3.054C3.28603 2.99833 3.76787 2.95232 4.2505 2.916"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.375 10.125H9.625M7 7.5V12.75"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Concurrent therapy':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M14 12.8V11.6C14 10.4817 13.2351 9.54204 12.2 9.27561M10.1 2.17446C10.9795 2.53049 11.6 3.39279 11.6 4.4C11.6 5.40721 10.9795 6.26951 10.1 6.62555M11 12.8C11 11.6817 11 11.1226 10.8173 10.6816C10.5737 10.0935 10.1065 9.62628 9.51844 9.38269C9.07739 9.2 8.51826 9.2 7.4 9.2H5.6C4.48174 9.2 3.92261 9.2 3.48156 9.38269C2.89349 9.62628 2.42627 10.0935 2.18269 10.6816C2 11.1226 2 11.6817 2 12.8M8.9 4.4C8.9 5.72548 7.82548 6.8 6.5 6.8C5.17452 6.8 4.1 5.72548 4.1 4.4C4.1 3.07452 5.17452 2 6.5 2C7.82548 2 8.9 3.07452 8.9 4.4Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Group therapy':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M13.033 11.5533C13.3838 11.3137 13.5567 11.2658 13.9812 11.2503C14.4058 11.2349 14.8261 11.3399 15.1934 11.5533C15.5608 11.7667 15.8602 12.0798 16.0571 12.4563C16.2539 12.8328 16.3401 13.2573 16.3058 13.6807C15.4059 13.9953 14.4501 14.1176 13.5 14.04C13.4971 13.19 13.3274 11.9677 12.8693 11.2516C12.4627 10.6139 11.8269 9.91653 11.1637 9.55313C10.5005 9.18973 9.7563 8.99949 9.00005 9C8.24393 8.99961 7.49992 9.18992 6.83685 9.55331C6.17377 9.9167 5.53729 10.614 5.13079 11.2516M13.4993 14.0392L13.5 14.0625C13.5 14.2312 13.491 14.3978 13.4723 14.562C12.1113 15.3428 10.5691 15.7525 9.00005 15.75C7.37255 15.75 5.8448 15.318 4.5278 14.562C4.50852 14.3884 4.49925 14.2139 4.50005 14.0392M4.50005 14.0392C3.55027 14.1197 2.59498 13.9978 1.6958 13.6815C1.66156 13.2582 1.74785 12.8338 1.94467 12.4574C2.1415 12.0811 2.44083 11.7681 2.80805 11.5547C3.17528 11.3413 3.5954 11.2362 4.01984 11.2516C4.44428 11.267 4.87488 11.5533 5.13079 11.2516M4.50005 14.0392C4.50274 13.1893 4.67301 11.9677 5.13079 11.2516M11.25 5.0625C11.25 5.65924 11.013 6.23153 10.591 6.65349C10.1691 7.07545 9.59679 7.3125 9.00005 7.3125C8.40331 7.3125 7.83102 7.07545 7.40906 6.65349C6.9871 6.23153 6.75005 5.65924 6.75005 5.0625C6.75005 4.46576 6.9871 3.89347 7.40906 3.47151C7.83102 3.04955 8.40331 2.8125 9.00005 2.8125C9.59679 2.8125 10.1691 3.04955 10.591 3.47151C11.013 3.89347 11.25 4.46576 11.25 5.0625ZM15.75 7.3125C15.75 7.53411 15.7064 7.75354 15.6216 7.95828C15.5368 8.16302 15.4125 8.34904 15.2558 8.50574C15.0991 8.66244 14.9131 8.78674 14.7083 8.87155C14.5036 8.95635 14.2842 9 14.0625 9C13.8409 9 13.6215 8.95635 13.4168 8.87155C13.212 8.78674 13.026 8.66244 12.8693 8.50574C12.7126 8.34904 12.5883 8.16302 12.5035 7.95828C12.4187 7.75354 12.375 7.53411 12.375 7.3125C12.375 6.86495 12.5528 6.43573 12.8693 6.11926C13.1858 5.80279 13.615 5.625 14.0625 5.625C14.5101 5.625 14.9393 5.80279 15.2558 6.11926C15.5723 6.43573 15.75 6.86495 15.75 7.3125ZM5.62505 7.3125C5.62505 7.53411 5.5814 7.75354 5.4966 7.95828C5.41179 8.16302 5.28749 8.34904 5.13079 8.50574C4.97409 8.66244 4.78807 8.78674 4.58333 8.87155C4.37859 8.95635 4.15916 9 3.93755 9C3.71594 9 3.49651 8.95635 3.29177 8.87155C3.08703 8.78674 2.90101 8.66244 2.74431 8.50574C2.58761 8.34904 2.46331 8.16302 2.3785 7.95828C2.2937 7.75354 2.25005 7.53411 2.25005 7.3125C2.25005 6.86495 2.42784 6.43573 2.74431 6.11926C3.06077 5.80279 3.49 5.625 3.93755 5.625C4.3851 5.625 4.81432 5.80279 5.13079 6.11926C5.44726 6.43573 5.62505 6.86495 5.62505 7.3125Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 12H11M9 10.5V13.5"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Evaluation':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M3.14551 2.25V10.6875C3.14551 11.1351 3.3233 11.5643 3.63977 11.8807C3.95623 12.1972 4.38545 12.375 4.83301 12.375H6.52051M3.14551 2.25H2.02051M3.14551 2.25H15.5205M6.52051 12.375H12.1455M6.52051 12.375L5.77051 14.625M15.5205 2.25H16.6455M15.5205 2.25V10.6875C15.5205 11.1351 15.3427 11.5643 15.0263 11.8807C14.7098 12.1972 14.2806 12.375 13.833 12.375H12.1455M12.1455 12.375L12.8955 14.625M5.77051 14.625H12.8955M5.77051 14.625L5.39551 15.75M12.8955 14.625L13.2705 15.75M5.95801 9L8.20801 6.75L9.81901 8.361C10.5759 7.27447 11.5621 6.36737 12.708 5.70375"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Recertification':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M6.33366 14.6615H10.3337C13.667 14.6615 15.0003 13.3281 15.0003 9.99479V5.99479C15.0003 2.66146 13.667 1.32812 10.3337 1.32812H6.33366C3.00033 1.32812 1.66699 2.66146 1.66699 5.99479V9.99479C1.66699 13.3281 3.00033 14.6615 6.33366 14.6615Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.44667 5.0026C9.11333 4.9026 8.74667 4.83594 8.33333 4.83594C6.49333 4.83594 5 6.32927 5 8.16927C5 10.0093 6.49333 11.5026 8.33333 11.5026C10.1733 11.5026 11.6667 10.0093 11.6667 8.16927C11.6667 7.4826 11.46 6.84927 11.1067 6.31594"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.92015 5.09365L8.81348 3.82031"
            stroke="#B5BCC4"
            strokeWidth="0.96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.92029 5.09375L8.62695 6.04042"
            stroke="#B5BCC4"
            strokeWidth="0.96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Daily Session Note':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M9 2.16172V4.64004C9 4.97607 9 5.14409 9.0654 5.27244C9.12292 5.38533 9.21471 5.47712 9.32761 5.53465C9.45595 5.60004 9.62397 5.60004 9.96 5.60004H12.4383M10.2 8.6H5.4M10.2 11H5.4M6.6 6.2H5.4M9 2H5.88C4.87191 2 4.36786 2 3.98282 2.19619C3.64413 2.36876 3.36876 2.64413 3.19619 2.98282C3 3.36786 3 3.87191 3 4.88V11.12C3 12.1281 3 12.6321 3.19619 13.0172C3.36876 13.3559 3.64413 13.6312 3.98282 13.8038C4.36786 14 4.87191 14 5.88 14H9.72C10.7281 14 11.2321 14 11.6172 13.8038C11.9559 13.6312 12.2312 13.3559 12.4038 13.0172C12.6 12.6321 12.6 12.1281 12.6 11.12V5.6L9 2Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Screenings':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M8.91699 5.45833H12.667M8.91699 8.625H12.667M8.91699 11.7917H12.667M8.16699 1.5H4.79199C4.17099 1.5 3.66699 2.032 3.66699 2.6875V14.5625C3.66699 15.218 4.17099 15.75 4.79199 15.75H14.542C15.163 15.75 15.667 15.218 15.667 14.5625V2.6875C15.667 2.032 15.163 1.5 14.542 1.5H8.16699ZM6.66699 5.45833H6.67499V5.46678H6.66699V5.45833ZM6.66699 8.625H6.67499V8.63345H6.66699V8.625ZM6.66699 11.7917H6.67499V11.8001H6.66699V11.7917Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Insurance call':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M2.35449 5.0625C2.35449 11.2755 7.39149 16.3125 13.6045 16.3125H15.292C15.7395 16.3125 16.1688 16.1347 16.4852 15.8182C16.8017 15.5018 16.9795 15.0726 16.9795 14.625V13.596C16.9795 13.209 16.7162 12.8715 16.3405 12.7778L13.0232 11.9482C12.6932 11.8657 12.3467 11.9895 12.1435 12.261L11.416 13.2308C11.2045 13.5128 10.8392 13.6372 10.5085 13.5157C9.28065 13.0643 8.16561 12.3514 7.24058 11.4264C6.31555 10.5014 5.60265 9.38634 5.15124 8.1585C5.02974 7.82775 5.15424 7.4625 5.43624 7.251L6.40599 6.5235C6.67824 6.32025 6.80124 5.973 6.71874 5.64375L5.88924 2.3265C5.8436 2.14402 5.73828 1.98203 5.59003 1.86625C5.44178 1.75048 5.25909 1.68756 5.07099 1.6875H4.04199C3.59444 1.6875 3.16522 1.86529 2.84875 2.18176C2.53228 2.49822 2.35449 2.92745 2.35449 3.375V5.0625Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Addendum Notes':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6.66683 13.1022V13.1116H6.67572M8.3335 1.66699H4.5835C3.8935 1.66699 3.3335 2.2581 3.3335 2.98644V16.1809C3.3335 16.9092 3.8935 17.5003 4.5835 17.5003H15.4168C16.1068 17.5003 16.6668 16.9092 16.6668 16.1809V2.98644C16.6668 2.2581 16.1068 1.66699 15.4168 1.66699H8.3335ZM6.66683 6.06514H6.67572V6.07452H6.66683V6.06514Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Weekly Progress Notes':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 5.24204C8.62634 4.00984 6.84533 3.32949 5 3.33204C4.12333 3.33204 3.28167 3.48204 2.5 3.75871V15.6337C3.30302 15.3504 4.14847 15.2061 5 15.207C6.92083 15.207 8.67333 15.9295 10 17.117M10 5.24204C11.3736 4.00977 13.1547 3.32941 15 3.33204C15.8767 3.33204 16.7183 3.48204 17.5 3.75871V15.6337C16.697 15.3504 15.8515 15.2061 15 15.207C13.1547 15.2045 11.3737 15.8848 10 17.117M10 5.24204V17.117"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Discharge':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.3335 7.59668H11.2257"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.07861 13.0889H7.45116"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.16699 13.0889H11.9121"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.059 9.33464V12.8209C17.059 15.2297 16.4482 15.8337 14.0119 15.8337H6.38056C3.94428 15.8337 3.3335 15.2297 3.3335 12.8209V7.17974C3.3335 4.77091 3.94428 4.16699 6.38056 4.16699H11.2257"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.2852 5.88268L14.3146 6.91209L17.0597 4.16699"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M3.14551 2.25V10.6875C3.14551 11.1351 3.3233 11.5643 3.63977 11.8807C3.95623 12.1972 4.38545 12.375 4.83301 12.375H6.52051M3.14551 2.25H2.02051M3.14551 2.25H15.5205M6.52051 12.375H12.1455M6.52051 12.375L5.77051 14.625M15.5205 2.25H16.6455M15.5205 2.25V10.6875C15.5205 11.1351 15.3427 11.5643 15.0263 11.8807C14.7098 12.1972 14.2806 12.375 13.833 12.375H12.1455M12.1455 12.375L12.8955 14.625M5.77051 14.625H12.8955M5.77051 14.625L5.39551 15.75M12.8955 14.625L13.2705 15.75M5.95801 9L8.20801 6.75L9.81901 8.361C10.5759 7.27447 11.5621 6.36737 12.708 5.70375"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};
export const ClipBoard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12 3C12.6975 3 13.0462 3 13.3323 3.07667C14.1088 3.28472 14.7153 3.8912 14.9233 4.66766C15 4.95378 15 5.30252 15 6V12.9C15 14.1601 15 14.7902 14.7548 15.2715C14.539 15.6948 14.1948 16.039 13.7715 16.2548C13.2902 16.5 12.6601 16.5 11.4 16.5H6.6C5.33988 16.5 4.70982 16.5 4.22852 16.2548C3.80516 16.039 3.46095 15.6948 3.24524 15.2715C3 14.7902 3 14.1601 3 12.9V6C3 5.30252 3 4.95378 3.07667 4.66766C3.28472 3.8912 3.8912 3.28472 4.66766 3.07667C4.95378 3 5.30252 3 6 3M7.2 4.5H10.8C11.22 4.5 11.4301 4.5 11.5905 4.41826C11.7316 4.34635 11.8463 4.23161 11.9183 4.09049C12 3.93006 12 3.72004 12 3.3V2.7C12 2.27996 12 2.06994 11.9183 1.90951C11.8463 1.76839 11.7316 1.65365 11.5905 1.58175C11.4301 1.5 11.22 1.5 10.8 1.5H7.2C6.77996 1.5 6.56994 1.5 6.40951 1.58175C6.26839 1.65365 6.15365 1.76839 6.08175 1.90951C6 2.06994 6 2.27996 6 2.7V3.3C6 3.72004 6 3.93006 6.08175 4.09049C6.15365 4.23161 6.26839 4.34635 6.40951 4.41826C6.56994 4.5 6.77996 4.5 7.2 4.5Z"
        stroke="#6C737F"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DocumentIcons = ({ iconType }: any) => {
  switch (iconType) {
    case 'weekly':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.16671 6.06221H13.3334M9.16671 9.58073H13.3334M9.16671 13.0992H13.3334M8.33337 1.66406H4.58337C3.89337 1.66406 3.33337 2.25517 3.33337 2.98351V16.178C3.33337 16.9063 3.89337 17.4974 4.58337 17.4974H15.4167C16.1067 17.4974 16.6667 16.9063 16.6667 16.178V2.98351C16.6667 2.25517 16.1067 1.66406 15.4167 1.66406H8.33337ZM6.66671 6.06221H6.6756V6.07159H6.66671V6.06221ZM6.66671 9.58073H6.6756V9.59011H6.66671V9.58073ZM6.66671 13.0992H6.6756V13.1086H6.66671V13.0992Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'discharge':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.3335 7.59668H11.2257"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.07861 13.0889H7.45116"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.16699 13.0889H11.9121"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.059 9.33464V12.8209C17.059 15.2297 16.4482 15.8337 14.0119 15.8337H6.38056C3.94428 15.8337 3.3335 15.2297 3.3335 12.8209V7.17974C3.3335 4.77091 3.94428 4.16699 6.38056 4.16699H11.2257"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.2852 5.88268L14.3146 6.91209L17.0597 4.16699"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Individual therapy':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 16 18"
          fill="none"
        >
          <path
            d="M9.7495 2.916C9.6495 2.56223 9.43671 2.25079 9.14348 2.02904C8.85026 1.80729 8.49263 1.68736 8.125 1.6875H5.875C5.1025 1.6875 4.45 2.20725 4.2505 2.916M9.7495 2.916C9.79075 3.0615 9.8125 3.216 9.8125 3.375C9.8125 3.52418 9.75324 3.66726 9.64775 3.77275C9.54226 3.87824 9.39918 3.9375 9.25 3.9375H4.75C4.60082 3.9375 4.45774 3.87824 4.35225 3.77275C4.24676 3.66726 4.1875 3.52418 4.1875 3.375C4.1875 3.216 4.21 3.0615 4.2505 2.916M9.7495 2.916C10.234 2.95275 10.7155 2.9985 11.1948 3.054C12.0198 3.15 12.625 3.86175 12.625 4.69275V14.625C12.625 15.0726 12.4472 15.5018 12.1307 15.8182C11.8143 16.1347 11.3851 16.3125 10.9375 16.3125H3.0625C2.61495 16.3125 2.18573 16.1347 1.86926 15.8182C1.55279 15.5018 1.375 15.0726 1.375 14.625V4.69275C1.375 3.86175 1.9795 3.15 2.80525 3.054C3.28603 2.99833 3.76787 2.95232 4.2505 2.916"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.375 10.125H9.625M7 7.5V12.75"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Concurrent therapy':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M14 12.8V11.6C14 10.4817 13.2351 9.54204 12.2 9.27561M10.1 2.17446C10.9795 2.53049 11.6 3.39279 11.6 4.4C11.6 5.40721 10.9795 6.26951 10.1 6.62555M11 12.8C11 11.6817 11 11.1226 10.8173 10.6816C10.5737 10.0935 10.1065 9.62628 9.51844 9.38269C9.07739 9.2 8.51826 9.2 7.4 9.2H5.6C4.48174 9.2 3.92261 9.2 3.48156 9.38269C2.89349 9.62628 2.42627 10.0935 2.18269 10.6816C2 11.1226 2 11.6817 2 12.8M8.9 4.4C8.9 5.72548 7.82548 6.8 6.5 6.8C5.17452 6.8 4.1 5.72548 4.1 4.4C4.1 3.07452 5.17452 2 6.5 2C7.82548 2 8.9 3.07452 8.9 4.4Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Group therapy':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M13.033 11.5533C13.3838 11.3137 13.5567 11.2658 13.9812 11.2503C14.4058 11.2349 14.8261 11.3399 15.1934 11.5533C15.5608 11.7667 15.8602 12.0798 16.0571 12.4563C16.2539 12.8328 16.3401 13.2573 16.3058 13.6807C15.4059 13.9953 14.4501 14.1176 13.5 14.04C13.4971 13.19 13.3274 11.9677 12.8693 11.2516C12.4627 10.6139 11.8269 9.91653 11.1637 9.55313C10.5005 9.18973 9.7563 8.99949 9.00005 9C8.24393 8.99961 7.49992 9.18992 6.83685 9.55331C6.17377 9.9167 5.53729 10.614 5.13079 11.2516M13.4993 14.0392L13.5 14.0625C13.5 14.2312 13.491 14.3978 13.4723 14.562C12.1113 15.3428 10.5691 15.7525 9.00005 15.75C7.37255 15.75 5.8448 15.318 4.5278 14.562C4.50852 14.3884 4.49925 14.2139 4.50005 14.0392M4.50005 14.0392C3.55027 14.1197 2.59498 13.9978 1.6958 13.6815C1.66156 13.2582 1.74785 12.8338 1.94467 12.4574C2.1415 12.0811 2.44083 11.7681 2.80805 11.5547C3.17528 11.3413 3.5954 11.2362 4.01984 11.2516C4.44428 11.267 4.87488 11.5533 5.13079 11.2516M4.50005 14.0392C4.50274 13.1893 4.67301 11.9677 5.13079 11.2516M11.25 5.0625C11.25 5.65924 11.013 6.23153 10.591 6.65349C10.1691 7.07545 9.59679 7.3125 9.00005 7.3125C8.40331 7.3125 7.83102 7.07545 7.40906 6.65349C6.9871 6.23153 6.75005 5.65924 6.75005 5.0625C6.75005 4.46576 6.9871 3.89347 7.40906 3.47151C7.83102 3.04955 8.40331 2.8125 9.00005 2.8125C9.59679 2.8125 10.1691 3.04955 10.591 3.47151C11.013 3.89347 11.25 4.46576 11.25 5.0625ZM15.75 7.3125C15.75 7.53411 15.7064 7.75354 15.6216 7.95828C15.5368 8.16302 15.4125 8.34904 15.2558 8.50574C15.0991 8.66244 14.9131 8.78674 14.7083 8.87155C14.5036 8.95635 14.2842 9 14.0625 9C13.8409 9 13.6215 8.95635 13.4168 8.87155C13.212 8.78674 13.026 8.66244 12.8693 8.50574C12.7126 8.34904 12.5883 8.16302 12.5035 7.95828C12.4187 7.75354 12.375 7.53411 12.375 7.3125C12.375 6.86495 12.5528 6.43573 12.8693 6.11926C13.1858 5.80279 13.615 5.625 14.0625 5.625C14.5101 5.625 14.9393 5.80279 15.2558 6.11926C15.5723 6.43573 15.75 6.86495 15.75 7.3125ZM5.62505 7.3125C5.62505 7.53411 5.5814 7.75354 5.4966 7.95828C5.41179 8.16302 5.28749 8.34904 5.13079 8.50574C4.97409 8.66244 4.78807 8.78674 4.58333 8.87155C4.37859 8.95635 4.15916 9 3.93755 9C3.71594 9 3.49651 8.95635 3.29177 8.87155C3.08703 8.78674 2.90101 8.66244 2.74431 8.50574C2.58761 8.34904 2.46331 8.16302 2.3785 7.95828C2.2937 7.75354 2.25005 7.53411 2.25005 7.3125C2.25005 6.86495 2.42784 6.43573 2.74431 6.11926C3.06077 5.80279 3.49 5.625 3.93755 5.625C4.3851 5.625 4.81432 5.80279 5.13079 6.11926C5.44726 6.43573 5.62505 6.86495 5.62505 7.3125Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 12H11M9 10.5V13.5"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'evaluation':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M3.14551 2.25V10.6875C3.14551 11.1351 3.3233 11.5643 3.63977 11.8807C3.95623 12.1972 4.38545 12.375 4.83301 12.375H6.52051M3.14551 2.25H2.02051M3.14551 2.25H15.5205M6.52051 12.375H12.1455M6.52051 12.375L5.77051 14.625M15.5205 2.25H16.6455M15.5205 2.25V10.6875C15.5205 11.1351 15.3427 11.5643 15.0263 11.8807C14.7098 12.1972 14.2806 12.375 13.833 12.375H12.1455M12.1455 12.375L12.8955 14.625M5.77051 14.625H12.8955M5.77051 14.625L5.39551 15.75M12.8955 14.625L13.2705 15.75M5.95801 9L8.20801 6.75L9.81901 8.361C10.5759 7.27447 11.5621 6.36737 12.708 5.70375"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'recertification':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M7.49996 18.3307H12.5C16.6666 18.3307 18.3333 16.6641 18.3333 12.4974V7.4974C18.3333 3.33073 16.6666 1.66406 12.5 1.66406H7.49996C3.33329 1.66406 1.66663 3.33073 1.66663 7.4974V12.4974C1.66663 16.6641 3.33329 18.3307 7.49996 18.3307Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.3917 6.25521C10.975 6.13021 10.5167 6.04688 10 6.04688C7.70004 6.04688 5.83337 7.91354 5.83337 10.2135C5.83337 12.5135 7.70004 14.3802 10 14.3802C12.3 14.3802 14.1667 12.5135 14.1667 10.2135C14.1667 9.35521 13.9084 8.56354 13.4667 7.89688"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9834 6.37292L10.6001 4.78125"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9834 6.375L10.3667 7.55833"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'daily':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M9 2.16172V4.64004C9 4.97607 9 5.14409 9.0654 5.27244C9.12292 5.38533 9.21471 5.47712 9.32761 5.53465C9.45595 5.60004 9.62397 5.60004 9.96 5.60004H12.4383M10.2 8.6H5.4M10.2 11H5.4M6.6 6.2H5.4M9 2H5.88C4.87191 2 4.36786 2 3.98282 2.19619C3.64413 2.36876 3.36876 2.64413 3.19619 2.98282C3 3.36786 3 3.87191 3 4.88V11.12C3 12.1281 3 12.6321 3.19619 13.0172C3.36876 13.3559 3.64413 13.6312 3.98282 13.8038C4.36786 14 4.87191 14 5.88 14H9.72C10.7281 14 11.2321 14 11.6172 13.8038C11.9559 13.6312 12.2312 13.3559 12.4038 13.0172C12.6 12.6321 12.6 12.1281 12.6 11.12V5.6L9 2Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'Screenings':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M8.91699 5.45833H12.667M8.91699 8.625H12.667M8.91699 11.7917H12.667M8.16699 1.5H4.79199C4.17099 1.5 3.66699 2.032 3.66699 2.6875V14.5625C3.66699 15.218 4.17099 15.75 4.79199 15.75H14.542C15.163 15.75 15.667 15.218 15.667 14.5625V2.6875C15.667 2.032 15.163 1.5 14.542 1.5H8.16699ZM6.66699 5.45833H6.67499V5.46678H6.66699V5.45833ZM6.66699 8.625H6.67499V8.63345H6.66699V8.625ZM6.66699 11.7917H6.67499V11.8001H6.66699V11.7917Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Insurance call':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M2.35449 5.0625C2.35449 11.2755 7.39149 16.3125 13.6045 16.3125H15.292C15.7395 16.3125 16.1688 16.1347 16.4852 15.8182C16.8017 15.5018 16.9795 15.0726 16.9795 14.625V13.596C16.9795 13.209 16.7162 12.8715 16.3405 12.7778L13.0232 11.9482C12.6932 11.8657 12.3467 11.9895 12.1435 12.261L11.416 13.2308C11.2045 13.5128 10.8392 13.6372 10.5085 13.5157C9.28065 13.0643 8.16561 12.3514 7.24058 11.4264C6.31555 10.5014 5.60265 9.38634 5.15124 8.1585C5.02974 7.82775 5.15424 7.4625 5.43624 7.251L6.40599 6.5235C6.67824 6.32025 6.80124 5.973 6.71874 5.64375L5.88924 2.3265C5.8436 2.14402 5.73828 1.98203 5.59003 1.86625C5.44178 1.75048 5.25909 1.68756 5.07099 1.6875H4.04199C3.59444 1.6875 3.16522 1.86529 2.84875 2.18176C2.53228 2.49822 2.35449 2.92745 2.35449 3.375V5.0625Z"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
        >
          <path
            d="M3.14551 2.25V10.6875C3.14551 11.1351 3.3233 11.5643 3.63977 11.8807C3.95623 12.1972 4.38545 12.375 4.83301 12.375H6.52051M3.14551 2.25H2.02051M3.14551 2.25H15.5205M6.52051 12.375H12.1455M6.52051 12.375L5.77051 14.625M15.5205 2.25H16.6455M15.5205 2.25V10.6875C15.5205 11.1351 15.3427 11.5643 15.0263 11.8807C14.7098 12.1972 14.2806 12.375 13.833 12.375H12.1455M12.1455 12.375L12.8955 14.625M5.77051 14.625H12.8955M5.77051 14.625L5.39551 15.75M12.8955 14.625L13.2705 15.75M5.95801 9L8.20801 6.75L9.81901 8.361C10.5759 7.27447 11.5621 6.36737 12.708 5.70375"
            stroke="#B5BCC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};

export const StartBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <g clipPath="url(#clip0_4746_161994)">
        <path
          d="M15.5116 47.796L18.6786 37.4975C18.7989 37.1062 19.2137 36.8866 19.6049 37.0069L27.3978 39.4034C27.7891 39.5237 28.0087 39.9385 27.8884 40.3297L24.7213 50.6283C24.5258 51.2642 23.6562 51.3404 23.3531 50.748L21.3837 46.8994C21.1935 46.5277 20.734 46.3864 20.3678 46.5869L16.5761 48.664C15.9926 48.9836 15.316 48.432 15.5116 47.796Z"
          fill="url(#paint0_linear_4746_161994)"
          stroke="#EBEEFE"
          strokeWidth="0.135157"
        />
        <path
          d="M40.8167 46.9349L33.4814 39.0429C33.2027 38.7431 33.2199 38.2741 33.5197 37.9954L39.4916 32.4448C39.7914 32.1661 40.2604 32.1833 40.5391 32.4831L47.8743 40.3751C48.3273 40.8625 47.9584 41.6536 47.2939 41.62L42.9762 41.4012C42.5592 41.38 42.2071 41.7073 42.1977 42.1248L42.1006 46.447C42.0856 47.1122 41.2697 47.4223 40.8167 46.9349Z"
          fill="url(#paint1_linear_4746_161994)"
          stroke="#EBEEFE"
          strokeWidth="0.135157"
        />
        <path
          d="M22.893 7.77055C23.5258 10.5303 27.5575 10.1972 27.7286 7.37092C27.5583 10.1972 31.5205 11.0134 32.481 8.34985C31.5213 11.0137 35.0931 12.9131 36.7651 10.628C35.0938 12.9135 37.9858 15.7423 40.2338 14.0209C37.9863 15.743 39.9642 19.2719 42.6061 18.2535C39.9645 19.2727 40.868 23.2159 43.6899 22.9831C40.8681 23.2167 40.6241 27.2548 43.3972 27.8264C40.624 27.2556 39.2522 31.0614 41.7519 32.3911C39.2518 31.0621 36.8634 34.3272 38.8873 36.3074C36.8629 34.3278 33.6513 36.7878 35.0353 39.2579C33.6506 36.7882 29.8761 38.2438 30.5081 41.0037C29.8753 38.2439 25.8436 38.5771 25.6724 41.4034C25.8428 38.5771 21.8805 37.7609 20.9201 40.4244C21.8798 37.7606 18.308 35.8612 16.636 38.1463C18.3073 35.8608 15.4153 33.032 13.1673 34.7534C15.4148 33.0313 13.4369 29.5024 10.7949 30.5208C13.4366 29.5016 12.533 25.5584 9.7112 25.7912C12.533 25.5576 12.7769 21.5195 10.0038 20.9479C12.7771 21.5187 14.1489 17.7129 11.6491 16.3832C14.1492 17.7122 16.5376 14.4471 14.5138 12.4669C16.5382 14.4465 19.7497 11.9865 18.3658 9.51636C19.7505 11.9861 23.525 10.5305 22.893 7.77055Z"
          fill="url(#paint2_linear_4746_161994)"
          stroke="#EBEEFE"
          strokeWidth="0.135157"
          strokeLinejoin="round"
        />
        <rect
          x="13.4613"
          y="16.082"
          width="22.1004"
          height="22.1004"
          rx="11.0502"
          transform="rotate(-12.9061 13.4613 16.082)"
          fill="url(#paint3_linear_4746_161994)"
          stroke="#6366F1"
          strokeWidth="0.135157"
        />
        <rect
          x="16.8125"
          y="47.6016"
          width="4.44711"
          height="0.741185"
          rx="0.370592"
          transform="rotate(-27.9061 16.8125 47.6016)"
          fill="url(#paint4_linear_4746_161994)"
        />
        <rect
          width="4.44711"
          height="0.741185"
          rx="0.370592"
          transform="matrix(-0.999332 -0.0365372 -0.0365372 0.999332 46.4729 40.8047)"
          fill="url(#paint5_linear_4746_161994)"
        />
        <path
          d="M31.7999 16.2515C32.0284 15.8872 31.9195 15.4039 31.5391 15.2034C30.5665 14.6907 29.5171 14.3351 28.4298 14.1513C27.0862 13.9242 25.711 13.9639 24.3828 14.2683C23.0545 14.5726 21.7992 15.1356 20.6885 15.9251C19.7898 16.564 18.9999 17.3411 18.3476 18.2261C18.0925 18.5722 18.2049 19.0548 18.5692 19.2832C18.9335 19.5117 19.4114 19.3991 19.671 19.0564C20.2117 18.3429 20.8587 17.7147 21.5907 17.1943C22.5347 16.5233 23.6016 16.0448 24.7306 15.7861C25.8595 15.5275 27.0283 15.4937 28.1703 15.6867C29.0559 15.8364 29.9119 16.1202 30.7092 16.5271C31.0922 16.7225 31.5714 16.6158 31.7999 16.2515Z"
          fill="url(#paint6_linear_4746_161994)"
        />
        <path
          d="M25.0381 18.6261C25.1019 17.911 26.0435 17.6952 26.4123 18.3113L28.1449 21.2055C28.3098 21.481 28.6334 21.6189 28.9464 21.5472L32.2343 20.7938C32.9342 20.6334 33.4304 21.4623 32.9584 22.0034L30.7413 24.5456C30.5302 24.7876 30.499 25.1379 30.6639 25.4134L32.3965 28.3076C32.7653 28.9237 32.1303 29.6517 31.4698 29.3701L28.367 28.047C28.0716 27.9211 27.7287 27.9997 27.5177 28.2416L25.3005 30.7838C24.8286 31.3249 23.9399 30.9459 24.0037 30.2308L24.3032 26.871C24.3317 26.5511 24.151 26.2493 23.8557 26.1234L20.7528 24.8003C20.0924 24.5186 20.1781 23.5564 20.878 23.396L24.1659 22.6426C24.4789 22.5709 24.7101 22.3058 24.7386 21.986L25.0381 18.6261Z"
          fill="url(#paint7_linear_4746_161994)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4746_161994"
          x1="25.6943"
          y1="41.5638"
          x2="15.7286"
          y2="48.0311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9C59F0" />
          <stop
            offset="0.927083"
            stop-color="#ABADFF"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4746_161994"
          x1="40.5108"
          y1="35.0002"
          x2="41.1287"
          y2="46.8645"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9C59F0" />
          <stop
            offset="0.927083"
            stop-color="#ABADFF"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4746_161994"
          x1="22.893"
          y1="7.77055"
          x2="30.5081"
          y2="41.0037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7544FF" />
          <stop
            offset="1"
            stop-color="#7659C7"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4746_161994"
          x1="31.6135"
          y1="20.3073"
          x2="20.1837"
          y2="39.2185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C0C2FF" />
          <stop
            offset="1"
            stop-color="#8789DE"
            stop-opacity="0.76"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4746_161994"
          x1="20.9335"
          y1="47.7137"
          x2="20.8366"
          y2="48.6333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F8F8F8" />
          <stop
            offset="1"
            stop-color="#F9F9F9"
            stop-opacity="0.51"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4746_161994"
          x1="4.12099"
          y1="0.112128"
          x2="4.02408"
          y2="1.03174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F8F8F8" />
          <stop
            offset="1"
            stop-color="#F9F9F9"
            stop-opacity="0.51"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4746_161994"
          x1="33.715"
          y1="15.3508"
          x2="22.6085"
          y2="21.0828"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D2D1FF" />
          <stop
            offset="1"
            stop-color="#F9F9F9"
            stop-opacity="0.51"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4746_161994"
          x1="25.2407"
          y1="16.354"
          x2="29.0482"
          y2="32.9706"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#7544FF" />
          <stop
            offset="1"
            stop-color="#7659C7"
          />
        </linearGradient>
        <clipPath id="clip0_4746_161994">
          <rect
            width="45.9535"
            height="45.9535"
            fill="white"
            transform="translate(0 10.7344) rotate(-12.9061)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SkillsIcon = ({ iconType }: any) => {
  switch (iconType) {
    case 'SIT_TO_STAND':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="26"
          viewBox="0 0 28 26"
          fill="none"
        >
          <g clipPath="url(#clip0_6914_103726)">
            <path
              d="M9.14526 6.63581C10.5511 6.63581 11.6907 5.51585 11.6907 4.13431C11.6907 2.75277 10.5511 1.63281 9.14526 1.63281C7.73947 1.63281 6.59985 2.75277 6.59985 4.13431C6.59985 5.51585 7.73947 6.63581 9.14526 6.63581Z"
              fill="#70C278"
            />
            <path
              d="M15.9062 18.5906C15.2316 18.1112 14.9666 17.2363 15.2616 16.4632C15.7003 15.3134 17.1315 14.9239 18.0924 15.6926L18.8895 16.3303C19.3133 16.6693 19.5601 17.1827 19.5601 17.7255C19.5601 19.1769 17.9212 20.0227 16.7382 19.1819L15.9062 18.5906Z"
              fill="#70C278"
            />
            <path
              d="M19.7876 24.1425C19.7876 25.0217 19.0749 25.7344 18.1957 25.7344C17.3166 25.7344 16.6038 25.0217 16.6038 24.1425L16.6038 17.7751C16.6038 16.8959 17.3166 16.1832 18.1957 16.1832C19.0749 16.1832 19.7876 16.8959 19.7876 17.7751L19.7876 24.1425Z"
              fill="#70C278"
            />
            <path
              d="M22.4584 12.043C23.329 12.166 23.935 12.9713 23.8121 13.8418C23.6891 14.7124 22.8838 15.3184 22.0132 15.1955L15.7083 14.3051C14.8377 14.1822 14.2317 13.3768 14.3546 12.5063C14.4776 11.6357 15.2829 11.0297 16.1535 11.1526L22.4584 12.043Z"
              fill="#70C278"
            />
            <path
              d="M12.2728 18.6845C11.6657 19.3204 10.6581 19.3438 10.0221 18.7368C9.38618 18.1297 9.36278 17.1221 9.96984 16.4861L14.3666 11.8803C14.9736 11.2444 15.9813 11.221 16.6172 11.828C17.2532 12.4351 17.2766 13.4427 16.6695 14.0787L12.2728 18.6845Z"
              fill="#70C278"
            />
            <path
              d="M7.4925 9.93164C7.24909 8.69793 8.06516 7.48852 9.31525 7.23035C10.5653 6.97219 11.776 7.76302 12.0195 8.99674L13.0617 16.4108C13.3051 17.6445 12.489 18.8539 11.239 19.1121C9.42825 19.486 8.77816 18.5794 8.53475 17.3457L7.4925 9.93164Z"
              fill="#70C278"
            />
            <path
              d="M9.21997 9.92889C8.46977 9.64481 8.10283 8.80935 8.40038 8.06283C8.69794 7.31632 9.52815 7.193 10.284 7.23494C11.0398 7.27688 14.3582 9.37756 14.3582 9.37756C15.1084 9.66164 15.4753 10.4971 15.1778 11.2436C14.8802 11.9901 14.0308 12.365 13.2806 12.0809L9.21997 9.92889Z"
              fill="#70C278"
            />
            <path
              d="M14.2351 12.3524C13.4815 12.4641 12.7904 11.9423 12.6914 11.187C12.5924 10.4316 13.123 9.72866 13.8766 9.61696L17.2834 9.11199C18.037 9.00029 18.7281 9.52209 18.8271 10.2775C18.9261 11.0328 18.3955 11.7358 17.6419 11.8475L14.2351 12.3524Z"
              fill="#70C278"
            />
            <rect
              x="4.77856"
              y="7.54688"
              width="1.81929"
              height="18.1927"
              rx="0.909644"
              fill="#70C278"
            />
            <rect
              x="5.68774"
              y="21.6406"
              width="1.81927"
              height="7.27715"
              rx="0.909636"
              transform="rotate(-90 5.68774 21.6406)"
              fill="#70C278"
            />
            <rect
              x="12.9666"
              y="25.7344"
              width="1.81929"
              height="5.91264"
              rx="0.909644"
              transform="rotate(180 12.9666 25.7344)"
              fill="#70C278"
            />
          </g>
          <defs>
            <clipPath id="clip0_6914_103726">
              <rect
                width="26.3797"
                height="25.4698"
                fill="white"
                transform="translate(0.685791 0.265625)"
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'STANDING_TOLERANCE':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M16.8816 6.69766C17.6351 6.69766 18.246 6.08677 18.246 5.3332C18.246 4.57964 17.6351 3.96875 16.8816 3.96875C16.128 3.96875 15.5171 4.57964 15.5171 5.3332C15.5171 6.08677 16.128 6.69766 16.8816 6.69766Z"
            fill="#449DC8"
          />
          <path
            d="M6.94146 5.33113C8.32301 5.33113 9.44298 4.21117 9.44298 2.82963C9.44298 1.44808 8.32301 0.328125 6.94146 0.328125C5.55991 0.328125 4.43994 1.44808 4.43994 2.82963C4.43994 4.21117 5.55991 5.33113 6.94146 5.33113Z"
            fill="#70C278"
          />
          <path
            d="M7.24611 17.6172C6.65881 17.6172 6.1374 17.2414 5.95168 16.6842C5.65717 15.8007 6.31479 14.8883 7.24611 14.8883L13.085 14.8883C13.8386 14.8883 14.4495 15.4992 14.4495 16.2527C14.4495 17.0063 13.8386 17.6172 13.085 17.6172L7.24611 17.6172Z"
            fill="#70C278"
          />
          <rect
            x="14.5312"
            y="23.0703"
            width="2.72893"
            height="8.18673"
            rx="1.36447"
            transform="rotate(180 14.5312 23.0703)"
            fill="#70C278"
          />
          <path
            d="M4.97583 8.51628C4.97583 7.26033 5.99398 6.24219 7.24994 6.24219C8.5059 6.24219 9.52405 7.26033 9.52405 8.51628L9.52405 15.3386C9.52405 16.5945 8.5059 17.6126 7.24994 17.6126C5.43073 17.6126 4.97583 16.5945 4.97583 15.3386L4.97583 8.51628Z"
            fill="#70C278"
          />
          <path
            d="M6.64399 8.86256C5.97389 8.43313 5.77878 7.54178 6.20821 6.87168C6.63764 6.20158 7.46258 6.24866 8.18425 6.44237C8.90593 6.63608 12.2824 9.05259 12.2824 9.05259C12.9525 9.48201 13.1476 10.3734 12.7182 11.0435C12.2887 11.7136 11.3974 11.9087 10.7273 11.4792L6.64399 8.86256Z"
            fill="#70C278"
          />
          <path
            d="M12.6707 11.1404C12.1676 11.7014 11.3049 11.7484 10.7439 11.2454C10.1828 10.7423 10.1358 9.87965 10.6389 9.31859L13.3716 6.27095C13.8746 5.70989 14.7373 5.66288 15.2984 6.16594C15.8594 6.66901 15.9064 7.53166 15.4033 8.09272L12.6707 11.1404Z"
            fill="#70C278"
          />
          <rect
            x="1.79175"
            y="6.24219"
            width="1.81929"
            height="18.1927"
            rx="0.909644"
            fill="#70C278"
          />
          <rect
            x="2.70093"
            y="20.3359"
            width="1.81927"
            height="7.27715"
            rx="0.909636"
            transform="rotate(-90 2.70093 20.3359)"
            fill="#70C278"
          />
          <rect
            x="9.97974"
            y="24.4375"
            width="1.81929"
            height="5.91264"
            rx="0.909644"
            transform="rotate(180 9.97974 24.4375)"
            fill="#70C278"
          />
          <path
            d="M20.9699 7.53391C21.4235 7.53391 21.8589 7.69663 22.2028 7.98399L21.3096 8.87721L23.6988 9.08455L23.4915 6.69531L22.7491 7.43774C22.2598 7.00767 21.6277 6.76455 20.9699 6.76455C19.6493 6.76455 18.5326 7.70856 18.3145 9.00877L19.0734 9.1361C19.2288 8.20787 20.0267 7.53391 20.9699 7.53391Z"
            fill="#449DC8"
          />
          <path
            d="M20.9699 11.3834C20.5164 11.3834 20.0809 11.2207 19.737 10.9334L20.6302 10.0401L18.241 9.8328L18.4483 12.222L19.1907 11.4796C19.6801 11.9097 20.3121 12.1528 20.9699 12.1528C22.2905 12.1528 23.4072 11.2088 23.6254 9.90858L22.8664 9.78125C22.711 10.7095 21.9131 11.3834 20.9699 11.3834Z"
            fill="#449DC8"
          />
        </svg>
      );

    case 'STANDING_REACH':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="25"
          viewBox="0 0 28 25"
          fill="none"
        >
          <path
            d="M20.6386 6.88516C21.3922 6.88516 22.0031 6.27427 22.0031 5.5207C22.0031 4.76714 21.3922 4.15625 20.6386 4.15625C19.8851 4.15625 19.2742 4.76714 19.2742 5.5207C19.2742 6.27427 19.8851 6.88516 20.6386 6.88516Z"
            fill="#DF595D"
          />
          <path
            d="M11.3184 5.97175C12.7 5.97175 13.8199 4.85179 13.8199 3.47025C13.8199 2.08871 12.7 0.96875 11.3184 0.96875C9.93686 0.96875 8.81689 2.08871 8.81689 3.47025C8.81689 4.85179 9.93686 5.97175 11.3184 5.97175Z"
            fill="#70C278"
          />
          <rect
            width="2.72893"
            height="8.18673"
            rx="1.36447"
            transform="matrix(-0.965926 0.258817 -0.258821 -0.965925 15.3887 23.8828)"
            fill="#70C278"
          />
          <rect
            width="2.72893"
            height="8.18673"
            rx="1.36447"
            transform="matrix(0.965926 0.258817 0.258821 -0.965925 6.78345 23.8828)"
            fill="#70C278"
          />
          <path
            d="M9.27197 9.14128C9.27197 7.88533 10.2901 6.86719 11.5461 6.86719C12.802 6.86719 13.8202 7.88533 13.8202 9.14128L13.8202 15.9636C13.8202 17.2195 12.3472 16.8732 11.0913 16.8732C9.27205 16.8732 9.27197 17.2195 9.27197 15.9636L9.27197 9.14128Z"
            fill="#70C278"
          />
          <path
            d="M10.9401 9.48756C10.27 9.05813 10.0749 8.16678 10.5044 7.49668C10.9338 6.82658 11.7587 6.87366 12.4804 7.06737C13.2021 7.26108 16.5785 9.67759 16.5785 9.67759C17.2486 10.107 17.4437 10.9984 17.0143 11.6685C16.5849 12.3386 15.6935 12.5337 15.0234 12.1042L10.9401 9.48756Z"
            fill="#70C278"
          />
          <path
            d="M12.6909 9.14128C12.6909 7.88533 11.6728 6.86719 10.4168 6.86719C9.16085 6.86719 8.35923 7.88533 8.35923 9.14128L8.35923 15.9636C8.35923 17.2195 9.16085 17.1008 10.4168 17.1008C12.236 17.1008 12.6909 17.2195 12.6909 15.9636L12.6909 9.14128Z"
            fill="#70C278"
          />
          <path
            d="M11.0228 9.48756C11.6929 9.05813 11.888 8.16678 11.4585 7.49668C11.0291 6.82658 10.2042 6.87366 9.48249 7.06737C8.76082 7.26108 5.38438 9.67759 5.38438 9.67759C4.71427 10.107 4.51917 10.9984 4.9486 11.6685C5.37803 12.3386 6.26938 12.5337 6.93949 12.1042L11.0228 9.48756Z"
            fill="#70C278"
          />
          <rect
            x="7.45068"
            y="14.6016"
            width="2.72893"
            height="5.003"
            rx="1.36446"
            transform="rotate(180 7.45068 14.6016)"
            fill="#70C278"
          />
          <rect
            width="2.72892"
            height="6.8223"
            rx="1.36446"
            transform="matrix(-0.500002 -0.866021 0.86603 -0.499998 15.6375 12.6484)"
            fill="#70C278"
          />
          <path
            d="M8.35864 9.61175C8.35864 8.1046 9.58043 6.88281 11.0876 6.88281C12.5947 6.88281 13.8165 8.1046 13.8165 9.61175L13.8165 18.2533L8.35864 18.2533L8.35864 9.61175Z"
            fill="#70C278"
          />
          <path
            d="M24.7341 8.17454C25.1876 8.17454 25.6231 8.33726 25.967 8.62461L25.0737 9.51783L27.463 9.72518L27.2557 7.33594L26.5132 8.07837C26.0239 7.6483 25.3919 7.40518 24.7341 7.40518C23.4135 7.40518 22.2967 8.34918 22.0786 9.64939L22.8376 9.77672C22.993 8.84849 23.7908 8.17454 24.7341 8.17454Z"
            fill="#DF595D"
          />
          <path
            d="M24.7341 12.0241C24.2805 12.0241 23.8451 11.8613 23.5012 11.574L24.3944 10.6808L22.0051 10.4734L22.2125 12.8627L22.9549 12.1202C23.4442 12.5503 24.0763 12.7934 24.7341 12.7934C26.0547 12.7934 27.1714 11.8494 27.3895 10.5492L26.6305 10.4219C26.4751 11.3501 25.6773 12.0241 24.7341 12.0241Z"
            fill="#DF595D"
          />
        </svg>
      );

    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="25"
          viewBox="0 0 28 25"
          fill="none"
        >
          <path
            d="M20.6386 6.88516C21.3922 6.88516 22.0031 6.27427 22.0031 5.5207C22.0031 4.76714 21.3922 4.15625 20.6386 4.15625C19.8851 4.15625 19.2742 4.76714 19.2742 5.5207C19.2742 6.27427 19.8851 6.88516 20.6386 6.88516Z"
            fill="#DF595D"
          />
          <path
            d="M11.3184 5.97175C12.7 5.97175 13.8199 4.85179 13.8199 3.47025C13.8199 2.08871 12.7 0.96875 11.3184 0.96875C9.93686 0.96875 8.81689 2.08871 8.81689 3.47025C8.81689 4.85179 9.93686 5.97175 11.3184 5.97175Z"
            fill="#70C278"
          />
          <rect
            width="2.72893"
            height="8.18673"
            rx="1.36447"
            transform="matrix(-0.965926 0.258817 -0.258821 -0.965925 15.3887 23.8828)"
            fill="#70C278"
          />
          <rect
            width="2.72893"
            height="8.18673"
            rx="1.36447"
            transform="matrix(0.965926 0.258817 0.258821 -0.965925 6.78345 23.8828)"
            fill="#70C278"
          />
          <path
            d="M9.27197 9.14128C9.27197 7.88533 10.2901 6.86719 11.5461 6.86719C12.802 6.86719 13.8202 7.88533 13.8202 9.14128L13.8202 15.9636C13.8202 17.2195 12.3472 16.8732 11.0913 16.8732C9.27205 16.8732 9.27197 17.2195 9.27197 15.9636L9.27197 9.14128Z"
            fill="#70C278"
          />
          <path
            d="M10.9401 9.48756C10.27 9.05813 10.0749 8.16678 10.5044 7.49668C10.9338 6.82658 11.7587 6.87366 12.4804 7.06737C13.2021 7.26108 16.5785 9.67759 16.5785 9.67759C17.2486 10.107 17.4437 10.9984 17.0143 11.6685C16.5849 12.3386 15.6935 12.5337 15.0234 12.1042L10.9401 9.48756Z"
            fill="#70C278"
          />
          <path
            d="M12.6909 9.14128C12.6909 7.88533 11.6728 6.86719 10.4168 6.86719C9.16085 6.86719 8.35923 7.88533 8.35923 9.14128L8.35923 15.9636C8.35923 17.2195 9.16085 17.1008 10.4168 17.1008C12.236 17.1008 12.6909 17.2195 12.6909 15.9636L12.6909 9.14128Z"
            fill="#70C278"
          />
          <path
            d="M11.0228 9.48756C11.6929 9.05813 11.888 8.16678 11.4585 7.49668C11.0291 6.82658 10.2042 6.87366 9.48249 7.06737C8.76082 7.26108 5.38438 9.67759 5.38438 9.67759C4.71427 10.107 4.51917 10.9984 4.9486 11.6685C5.37803 12.3386 6.26938 12.5337 6.93949 12.1042L11.0228 9.48756Z"
            fill="#70C278"
          />
          <rect
            x="7.45068"
            y="14.6016"
            width="2.72893"
            height="5.003"
            rx="1.36446"
            transform="rotate(180 7.45068 14.6016)"
            fill="#70C278"
          />
          <rect
            width="2.72892"
            height="6.8223"
            rx="1.36446"
            transform="matrix(-0.500002 -0.866021 0.86603 -0.499998 15.6375 12.6484)"
            fill="#70C278"
          />
          <path
            d="M8.35864 9.61175C8.35864 8.1046 9.58043 6.88281 11.0876 6.88281C12.5947 6.88281 13.8165 8.1046 13.8165 9.61175L13.8165 18.2533L8.35864 18.2533L8.35864 9.61175Z"
            fill="#70C278"
          />
          <path
            d="M24.7341 8.17454C25.1876 8.17454 25.6231 8.33726 25.967 8.62461L25.0737 9.51783L27.463 9.72518L27.2557 7.33594L26.5132 8.07837C26.0239 7.6483 25.3919 7.40518 24.7341 7.40518C23.4135 7.40518 22.2967 8.34918 22.0786 9.64939L22.8376 9.77672C22.993 8.84849 23.7908 8.17454 24.7341 8.17454Z"
            fill="#DF595D"
          />
          <path
            d="M24.7341 12.0241C24.2805 12.0241 23.8451 11.8613 23.5012 11.574L24.3944 10.6808L22.0051 10.4734L22.2125 12.8627L22.9549 12.1202C23.4442 12.5503 24.0763 12.7934 24.7341 12.7934C26.0547 12.7934 27.1714 11.8494 27.3895 10.5492L26.6305 10.4219C26.4751 11.3501 25.6773 12.0241 24.7341 12.0241Z"
            fill="#DF595D"
          />
        </svg>
      );
  }
};

export const NoteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z"
        fill="white"
      />
    </svg>
  );
};

export const HistoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M14.4878 9.63085C14.291 11.4795 13.2435 13.2119 11.5102 14.2126C8.6305 15.8752 4.94822 14.8886 3.28561 12.0088L3.10853 11.7021M2.51191 8.36598C2.70868 6.51731 3.75616 4.78492 5.48944 3.78421C8.36916 2.1216 12.0514 3.10826 13.7141 5.98798L13.8911 6.2947M2.47437 13.2951L2.9929 11.3599L4.9281 11.8785M12.0716 6.11833L14.0068 6.63687L14.5254 4.70167M8.49986 5.8109V8.9984L10.2707 10.0609"
        stroke="#6C737F"
        strokeWidth="0.991667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShowMoreIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.9507 5.625L7.99997 8.56929L5.04925 5.625L4.14282 6.53143L7.99997 10.3886L11.8571 6.53143L10.9507 5.625Z"
        fill="#6C737F"
      />
    </svg>
  );
};

export const TaskInfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 11.1H7.6M9.4 14.7H7.6M14.8 7.5H7.6M18.4 7.32V16.68C18.4 18.1921 18.4 18.9482 18.1057 19.5258C17.8469 20.0338 17.4338 20.4469 16.9258 20.7057C16.3482 21 15.5921 21 14.08 21H8.32C6.80786 21 6.05179 21 5.47423 20.7057C4.96619 20.4469 4.55314 20.0338 4.29428 19.5258C4 18.9482 4 18.1921 4 16.68V7.32C4 5.80786 4 5.05179 4.29428 4.47423C4.55314 3.96619 4.96619 3.55314 5.47423 3.29428C6.05179 3 6.80786 3 8.32 3H14.08C15.5921 3 16.3482 3 16.9258 3.29428C17.4338 3.55314 17.8469 3.96619 18.1057 4.47423C18.4 5.05179 18.4 5.80786 18.4 7.32Z"
        stroke="#384250"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoteInfoIcon = () => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 11.1H8.1M9.9 14.7H8.1M15.3 7.5H8.1M18.9 7.32V16.68C18.9 18.1921 18.9 18.9482 18.6057 19.5258C18.3469 20.0338 17.9338 20.4469 17.4258 20.7057C16.8482 21 16.0921 21 14.58 21H8.82C7.30786 21 6.55179 21 5.97423 20.7057C5.46619 20.4469 5.05314 20.0338 4.79428 19.5258C4.5 18.9482 4.5 18.1921 4.5 16.68V7.32C4.5 5.80786 4.5 5.05179 4.79428 4.47423C5.05314 3.96619 5.46619 3.55314 5.97423 3.29428C6.55179 3 7.30786 3 8.82 3H14.58C16.0921 3 16.8482 3 17.4258 3.29428C17.9338 3.55314 18.3469 3.96619 18.6057 4.47423C18.9 5.05179 18.9 5.80786 18.9 7.32Z"
        stroke="#384250"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="13.5"
        y="13"
        width="12"
        height="12"
        rx="6"
        fill="#F5F7FF"
      />
      <g clipPath="url(#clip0_37184_94146)">
        <circle
          cx="19.5"
          cy="19"
          r="4"
          fill="#9747FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_37184_94146">
          <rect
            x="15.5"
            y="15"
            width="8"
            height="8"
            rx="4"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CodeCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.25 13.7L16.95 11L14.25 8.3M9.75 8.3L7.05 11L9.75 13.7M21 11C21 15.9706 16.9706 20 12 20C7.02944 20 3 15.9706 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z"
        stroke="#384250"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AwardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.86866 15.4599L7 22L11.5884 19.247C11.7381 19.1572 11.8129 19.1123 11.8928 19.0947C11.9634 19.0792 12.0366 19.0792 12.1072 19.0947C12.1871 19.1123 12.2619 19.1572 12.4116 19.247L17 22L16.1319 15.4571M16.4259 4.24888C16.5803 4.6224 16.8768 4.9193 17.25 5.0743L18.5589 5.61648C18.9325 5.77121 19.2292 6.06799 19.384 6.44154C19.5387 6.81509 19.5387 7.23481 19.384 7.60836L18.8422 8.91635C18.6874 9.29007 18.6872 9.71021 18.8427 10.0837L19.3835 11.3913C19.4602 11.5764 19.4997 11.7747 19.4997 11.975C19.4998 12.1752 19.4603 12.3736 19.3837 12.5586C19.3071 12.7436 19.1947 12.9118 19.0531 13.0534C18.9114 13.195 18.7433 13.3073 18.5582 13.3839L17.2503 13.9256C16.8768 14.0801 16.5799 14.3765 16.4249 14.7498L15.8827 16.0588C15.728 16.4323 15.4312 16.7291 15.0577 16.8838C14.6841 17.0386 14.2644 17.0386 13.8909 16.8838L12.583 16.342C12.2094 16.1877 11.7899 16.188 11.4166 16.3429L10.1077 16.8843C9.73434 17.0387 9.31501 17.0386 8.94178 16.884C8.56854 16.7293 8.27194 16.4329 8.11711 16.0598L7.57479 14.7504C7.42035 14.3769 7.12391 14.08 6.75064 13.925L5.44175 13.3828C5.06838 13.2282 4.77169 12.9316 4.61691 12.5582C4.46213 12.1849 4.46192 11.7654 4.61633 11.3919L5.1581 10.0839C5.31244 9.71035 5.31213 9.29079 5.15722 8.91746L4.61623 7.60759C4.53953 7.42257 4.50003 7.22426 4.5 7.02397C4.49997 6.82369 4.5394 6.62536 4.61604 6.44032C4.69268 6.25529 4.80504 6.08716 4.94668 5.94556C5.08832 5.80396 5.25647 5.69166 5.44152 5.61508L6.74947 5.07329C7.12265 4.91898 7.41936 4.6229 7.57448 4.25004L8.11664 2.94111C8.27136 2.56756 8.56813 2.27078 8.94167 2.11605C9.3152 1.96132 9.7349 1.96132 10.1084 2.11605L11.4164 2.65784C11.7899 2.81218 12.2095 2.81187 12.5828 2.65696L13.8922 2.11689C14.2657 1.96224 14.6853 1.96228 15.0588 2.11697C15.4322 2.27167 15.729 2.56837 15.8837 2.94182L16.426 4.25115L16.4259 4.24888Z"
        stroke="#384250"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8334 10.8307H10.8334V15.8307H9.16675V10.8307H4.16675V9.16406H9.16675V4.16406H10.8334V9.16406H15.8334V10.8307Z"
        fill="#6366F1"
      />
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99992 3.33594L8.82492 4.51094L13.4749 9.16927H3.33325V10.8359H13.4749L8.82492 15.4943L9.99992 16.6693L16.6666 10.0026L9.99992 3.33594Z"
        fill="#6366F1"
      />
    </svg>
  );
};

export const EmptyUpdatesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="156"
      viewBox="0 0 150 156"
      fill="none"
    >
      <g filter="url(#filter0_f_7198_54573)">
        <ellipse
          cx="71"
          cy="128"
          rx="35"
          ry="6"
          fill="#9DA4AE"
          fill-opacity="0.4"
        />
      </g>
      <path
        d="M75.2818 132.376C108.281 132.376 135.032 105.625 135.032 72.6255C135.032 39.6262 108.281 12.875 75.2818 12.875C42.2825 12.875 15.5312 39.6262 15.5312 72.6255C15.5312 105.625 42.2825 132.376 75.2818 132.376Z"
        fill="url(#paint0_linear_7198_54573)"
      />
      <path
        d="M107.517 26.7812H41.3258C37.2001 26.7812 33.8555 30.1258 33.8555 34.2516H114.987C114.987 30.1258 111.643 26.7812 107.517 26.7812Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <path
        d="M33.8555 34.0469H114.987V95.8382C114.987 98.5854 113.896 101.22 111.953 103.163C110.011 105.105 107.376 106.197 104.629 106.197H44.2141C41.4668 106.197 38.8321 105.105 36.8894 103.163C34.9468 101.22 33.8555 98.5854 33.8555 95.8382V34.0469Z"
        fill="url(#paint1_linear_7198_54573)"
      />
      <path
        d="M101.041 41.8516H47.8279C46.7197 41.8516 45.8213 42.749 45.8213 43.856C45.8213 44.963 46.7197 45.8604 47.8279 45.8604H101.041C102.149 45.8604 103.048 44.963 103.048 43.856C103.048 42.749 102.149 41.8516 101.041 41.8516Z"
        fill="url(#paint2_linear_7198_54573)"
      />
      <path
        d="M101.041 58.8828H47.8279C46.7197 58.8828 45.8213 59.7802 45.8213 60.8872C45.8213 61.9942 46.7197 62.8916 47.8279 62.8916H101.041C102.149 62.8916 103.048 61.9942 103.048 60.8872C103.048 59.7802 102.149 58.8828 101.041 58.8828Z"
        fill="url(#paint3_linear_7198_54573)"
      />
      <path
        d="M101.041 75.9141H47.8279C46.7197 75.9141 45.8213 76.8115 45.8213 77.9185C45.8213 79.0255 46.7197 79.9229 47.8279 79.9229H101.041C102.149 79.9229 103.048 79.0255 103.048 77.9185C103.048 76.8115 102.149 75.9141 101.041 75.9141Z"
        fill="url(#paint4_linear_7198_54573)"
      />
      <path
        d="M101.042 92.9453H47.8288C46.7206 92.9453 45.8223 93.8427 45.8223 94.9497C45.8223 96.0567 46.7206 96.9541 47.8288 96.9541H101.042C102.15 96.9541 103.049 96.0567 103.049 94.9497C103.049 93.8427 102.15 92.9453 101.042 92.9453Z"
        fill="url(#paint5_linear_7198_54573)"
      />
      <path
        d="M47.4678 72.2656H19.1325C16.8561 72.2656 15.0107 74.111 15.0107 76.3874V116.888C15.0107 119.164 16.8561 121.01 19.1325 121.01H47.4678C49.7442 121.01 51.5895 119.164 51.5895 116.888V76.3874C51.5895 74.111 49.7442 72.2656 47.4678 72.2656Z"
        fill="url(#paint6_linear_7198_54573)"
      />
      <g filter="url(#filter1_d_7198_54573)">
        <path
          d="M128.129 9H96.8321C95.3737 9 94.1914 10.1823 94.1914 11.6407V26.3512C94.1914 27.8097 95.3737 28.9919 96.8321 28.9919H128.129C129.588 28.9919 130.77 27.8097 130.77 26.3512V11.6407C130.77 10.1823 129.588 9 128.129 9Z"
          fill="url(#paint7_linear_7198_54573)"
        />
      </g>
      <path
        d="M44.3058 92.5234H22.2942C21.553 92.5234 20.9521 93.1243 20.9521 93.8655V93.8698C20.9521 94.611 21.553 95.2119 22.2942 95.2119H44.3058C45.047 95.2119 45.6478 94.611 45.6478 93.8698V93.8655C45.6478 93.1243 45.047 92.5234 44.3058 92.5234Z"
        fill="url(#paint8_linear_7198_54573)"
      />
      <path
        d="M44.3189 111.445H22.4965C21.7617 111.445 21.166 112.027 21.166 112.746V112.75C21.166 113.468 21.7617 114.05 22.4965 114.05H44.3189C45.0538 114.05 45.6495 113.468 45.6495 112.75V112.746C45.6495 112.027 45.0538 111.445 44.3189 111.445Z"
        fill="url(#paint9_linear_7198_54573)"
      />
      <path
        d="M44.3189 101.547H22.4965C21.7617 101.547 21.166 102.129 21.166 102.847V102.851C21.166 103.569 21.7617 104.151 22.4965 104.151H44.3189C45.0538 104.151 45.6495 103.569 45.6495 102.851V102.847C45.6495 102.129 45.0538 101.547 44.3189 101.547Z"
        fill="url(#paint10_linear_7198_54573)"
      />
      <path
        d="M30.3423 78.5156H23.91C22.4851 78.5156 21.3301 79.6707 21.3301 81.0955V82.8806C21.3301 84.3054 22.4851 85.4605 23.91 85.4605H30.3423C31.7671 85.4605 32.9222 84.3054 32.9222 82.8806V81.0955C32.9222 79.6707 31.7671 78.5156 30.3423 78.5156Z"
        fill="url(#paint11_linear_7198_54573)"
      />
      <path
        d="M101.916 22.0328C103.593 22.0328 104.952 20.6736 104.952 18.9969C104.952 17.3202 103.593 15.9609 101.916 15.9609C100.239 15.9609 98.8799 17.3202 98.8799 18.9969C98.8799 20.6736 100.239 22.0328 101.916 22.0328Z"
        fill="#A9ABF5"
      />
      <path
        d="M112.765 22.0328C114.442 22.0328 115.801 20.6736 115.801 18.9969C115.801 17.3202 114.442 15.9609 112.765 15.9609C111.089 15.9609 109.729 17.3202 109.729 18.9969C109.729 20.6736 111.089 22.0328 112.765 22.0328Z"
        fill="#A9ABF5"
      />
      <path
        d="M123.614 22.0328C125.291 22.0328 126.65 20.6736 126.65 18.9969C126.65 17.3202 125.291 15.9609 123.614 15.9609C121.937 15.9609 120.578 17.3202 120.578 18.9969C120.578 20.6736 121.937 22.0328 123.614 22.0328Z"
        fill="#A9ABF5"
      />
      <g filter="url(#filter2_f_7198_54573)">
        <ellipse
          cx="92.4492"
          cy="95.6875"
          rx="19"
          ry="3"
          fill="#1F2A37"
          fill-opacity="0.3"
        />
      </g>
      <path
        d="M69.5852 117.409C70.0576 115.453 72.8409 115.453 73.3132 117.409C73.482 118.109 74.028 118.655 74.7273 118.823C76.6841 119.296 76.6841 122.079 74.7273 122.552C74.028 122.72 73.482 123.266 73.3132 123.966C72.8409 125.922 70.0576 125.922 69.5852 123.966C69.4164 123.266 68.8704 122.72 68.1711 122.552C66.2143 122.079 66.2143 119.296 68.1711 118.823C68.8704 118.655 69.4164 118.109 69.5852 117.409Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <path
        d="M24.6443 39.6159C24.9879 38.1928 27.0121 38.1928 27.3557 39.6159C27.4784 40.1245 27.8755 40.5216 28.3841 40.6443C29.8072 40.9879 29.8072 43.0121 28.3841 43.3557C27.8755 43.4784 27.4784 43.8755 27.3557 44.3841C27.0121 45.8072 24.9879 45.8072 24.6443 44.3841C24.5216 43.8755 24.1245 43.4784 23.6159 43.3557C22.1928 43.0121 22.1928 40.9879 23.6159 40.6443C24.1245 40.5216 24.5216 40.1245 24.6443 39.6159Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <path
        d="M26.5852 17.4094C27.0576 15.4526 29.8409 15.4526 30.3132 17.4094C30.482 18.1087 31.028 18.6547 31.7273 18.8235C33.6841 19.2958 33.6841 22.0792 31.7273 22.5515C31.028 22.7203 30.482 23.2663 30.3132 23.9656C29.8409 25.9224 27.0576 25.9224 26.5852 23.9656C26.4164 23.2663 25.8704 22.7203 25.1711 22.5515C23.2143 22.0792 23.2143 19.2958 25.1711 18.8235C25.8704 18.6547 26.4164 18.1087 26.5852 17.4094Z"
        fill="#6366F1"
        fill-opacity="0.5"
      />
      <mask
        id="path-22-inside-1_7198_54573"
        fill="white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.8993 14.7664C73.9067 14.7664 74.7234 13.9497 74.7234 12.9422C74.7234 11.9348 73.9067 11.1181 72.8993 11.1181C71.8918 11.1181 71.0751 11.9348 71.0751 12.9422C71.0751 13.9497 71.8918 14.7664 72.8993 14.7664ZM72.8993 16.1345C74.6623 16.1345 76.0915 14.7053 76.0915 12.9422C76.0915 11.1792 74.6623 9.75 72.8993 9.75C71.1362 9.75 69.707 11.1792 69.707 12.9422C69.707 14.7053 71.1362 16.1345 72.8993 16.1345Z"
        />
      </mask>
      <path
        d="M72.0971 12.9422C72.0971 12.4992 72.4562 12.1401 72.8993 12.1401V17.3927C75.3572 17.3927 77.3497 15.4001 77.3497 12.9422H72.0971ZM72.8993 13.7444C72.4562 13.7444 72.0971 13.3853 72.0971 12.9422H77.3497C77.3497 10.4843 75.3572 8.4918 72.8993 8.4918V13.7444ZM73.7014 12.9422C73.7014 13.3853 73.3423 13.7444 72.8993 13.7444V8.4918C70.4414 8.4918 68.4488 10.4843 68.4488 12.9422H73.7014ZM72.8993 12.1401C73.3423 12.1401 73.7014 12.4992 73.7014 12.9422H68.4488C68.4488 15.4001 70.4414 17.3927 72.8993 17.3927V12.1401ZM73.4652 12.9422C73.4652 13.2548 73.2118 13.5082 72.8993 13.5082V18.7608C76.1128 18.7608 78.7178 16.1557 78.7178 12.9422H73.4652ZM72.8993 12.3763C73.2118 12.3763 73.4652 12.6297 73.4652 12.9422H78.7178C78.7178 9.72875 76.1128 7.1237 72.8993 7.1237V12.3763ZM72.3333 12.9422C72.3333 12.6297 72.5867 12.3763 72.8993 12.3763V7.1237C69.6858 7.1237 67.0807 9.72875 67.0807 12.9422H72.3333ZM72.8993 13.5082C72.5867 13.5082 72.3333 13.2548 72.3333 12.9422H67.0807C67.0807 16.1557 69.6858 18.7608 72.8993 18.7608V13.5082Z"
        fill="#111927"
        fill-opacity="0.38"
        mask="url(#path-22-inside-1_7198_54573)"
      />
      <mask
        id="path-24-inside-2_7198_54573"
        fill="white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M133.848 41.3367C134.856 41.3367 135.673 40.52 135.673 39.5126C135.673 38.5051 134.856 37.6884 133.848 37.6884C132.841 37.6884 132.024 38.5051 132.024 39.5126C132.024 40.52 132.841 41.3367 133.848 41.3367ZM133.848 42.7048C135.612 42.7048 137.041 41.2756 137.041 39.5126C137.041 37.7495 135.612 36.3203 133.848 36.3203C132.085 36.3203 130.656 37.7495 130.656 39.5126C130.656 41.2756 132.085 42.7048 133.848 42.7048Z"
        />
      </mask>
      <path
        d="M133.046 39.5126C133.046 39.0695 133.405 38.7104 133.848 38.7104V43.963C136.306 43.963 138.299 41.9705 138.299 39.5126H133.046ZM133.848 40.3147C133.405 40.3147 133.046 39.9556 133.046 39.5126H138.299C138.299 37.0546 136.306 35.0621 133.848 35.0621V40.3147ZM134.651 39.5126C134.651 39.9556 134.292 40.3147 133.848 40.3147V35.0621C131.391 35.0621 129.398 37.0546 129.398 39.5126H134.651ZM133.848 38.7104C134.292 38.7104 134.651 39.0695 134.651 39.5126H129.398C129.398 41.9705 131.391 43.963 133.848 43.963V38.7104ZM134.414 39.5126C134.414 39.8251 134.161 40.0785 133.848 40.0785V45.3311C137.062 45.3311 139.667 42.726 139.667 39.5126H134.414ZM133.848 38.9466C134.161 38.9466 134.414 39.2 134.414 39.5126H139.667C139.667 36.2991 137.062 33.694 133.848 33.694V38.9466ZM133.283 39.5126C133.283 39.2 133.536 38.9466 133.848 38.9466V33.694C130.635 33.694 128.03 36.2991 128.03 39.5126H133.283ZM133.848 40.0785C133.536 40.0785 133.283 39.8251 133.283 39.5126H128.03C128.03 42.726 130.635 45.3311 133.848 45.3311V40.0785Z"
        fill="#111927"
        fill-opacity="0.38"
        mask="url(#path-24-inside-2_7198_54573)"
      />
      <mask
        id="path-26-inside-3_7198_54573"
        fill="white"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M140.192 28.0164C141.2 28.0164 142.016 27.1997 142.016 26.1922C142.016 25.1848 141.2 24.3681 140.192 24.3681C139.185 24.3681 138.368 25.1848 138.368 26.1922C138.368 27.1997 139.185 28.0164 140.192 28.0164ZM140.192 29.3845C141.955 29.3845 143.384 27.9553 143.384 26.1922C143.384 24.4292 141.955 23 140.192 23C138.429 23 137 24.4292 137 26.1922C137 27.9553 138.429 29.3845 140.192 29.3845Z"
        />
      </mask>
      <path
        d="M139.39 26.1922C139.39 25.7492 139.749 25.3901 140.192 25.3901V30.6427C142.65 30.6427 144.643 28.6501 144.643 26.1922H139.39ZM140.192 26.9944C139.749 26.9944 139.39 26.6353 139.39 26.1922H144.643C144.643 23.7343 142.65 21.7418 140.192 21.7418V26.9944ZM140.994 26.1922C140.994 26.6353 140.635 26.9944 140.192 26.9944V21.7418C137.734 21.7418 135.742 23.7343 135.742 26.1922H140.994ZM140.192 25.3901C140.635 25.3901 140.994 25.7492 140.994 26.1922H135.742C135.742 28.6501 137.734 30.6427 140.192 30.6427V25.3901ZM140.758 26.1922C140.758 26.5048 140.505 26.7582 140.192 26.7582V32.0108C143.406 32.0108 146.011 29.4057 146.011 26.1922H140.758ZM140.192 25.6263C140.505 25.6263 140.758 25.8797 140.758 26.1922H146.011C146.011 22.9787 143.406 20.3737 140.192 20.3737V25.6263ZM139.626 26.1922C139.626 25.8797 139.88 25.6263 140.192 25.6263V20.3737C136.979 20.3737 134.374 22.9787 134.374 26.1922H139.626ZM140.192 26.7582C139.88 26.7582 139.626 26.5048 139.626 26.1922H134.374C134.374 29.4057 136.979 32.0108 140.192 32.0108V26.7582Z"
        fill="#111927"
        fill-opacity="0.38"
        mask="url(#path-26-inside-3_7198_54573)"
      />
      <path
        d="M149.983 91.6548C149.985 93.434 149.34 95.1532 148.168 96.4917C146.996 97.8303 145.378 98.6969 143.614 98.93C143.291 98.9711 142.967 98.9922 142.642 98.9932H118.235C117.705 98.9921 117.177 98.9485 116.654 98.8628C114.411 98.4757 112.39 97.2722 110.98 95.4841C109.571 93.6961 108.872 91.4498 109.019 89.1776C109.166 86.9054 110.149 84.7679 111.777 83.1766C113.406 81.5853 115.565 80.6527 117.84 80.5582C119.019 77.9979 120.998 75.8906 123.479 74.5539C125.961 73.2172 128.809 72.7238 131.595 73.148C134.382 73.5722 136.954 74.8911 138.926 76.9056C140.897 78.9202 142.16 81.5212 142.523 84.3163H142.634C143.599 84.3148 144.554 84.5034 145.446 84.8715C146.337 85.2396 147.147 85.7799 147.83 86.4615C148.513 87.1431 149.054 87.9526 149.424 88.8437C149.793 89.7349 149.983 90.6901 149.983 91.6548Z"
        fill="url(#paint12_linear_7198_54573)"
      />
      <path
        d="M9.61213e-06 112.585C-0.000866342 114.357 0.642363 116.068 1.80985 117.401C2.97733 118.734 4.58944 119.596 6.34579 119.828C6.66524 119.873 6.98737 119.895 7.3099 119.896H31.6103C32.1398 119.895 32.6684 119.851 33.1909 119.765C35.4375 119.391 37.4652 118.196 38.8804 116.411C40.2956 114.626 40.9974 112.379 40.8497 110.106C40.7021 107.833 39.7154 105.696 38.0811 104.109C36.4469 102.523 34.2817 101.6 32.0055 101.52C30.83 98.972 28.8585 96.8753 26.388 95.5456C23.9174 94.2158 21.0817 93.7251 18.308 94.1474C15.5344 94.5697 12.9731 95.8821 11.0101 97.8868C9.04707 99.8915 7.78867 102.48 7.42449 105.262H7.3099C6.34895 105.262 5.39744 105.452 4.50979 105.82C3.62214 106.188 2.81577 106.728 2.13683 107.408C1.45789 108.088 0.919695 108.895 0.553036 109.783C0.186377 110.672 -0.00154868 111.624 9.61213e-06 112.585Z"
        fill="url(#paint13_linear_7198_54573)"
      />
      <path
        d="M13.8887 27.0418C13.8887 28.5091 14.4715 29.9163 15.5089 30.9538C16.5463 31.9914 17.9534 32.5743 19.4205 32.5743H37.7861C39.5956 32.5647 41.3299 31.8489 42.6195 30.5793C43.9091 29.3097 44.6521 27.5867 44.6903 25.7774C44.7284 23.968 44.0586 22.2152 42.8236 20.8924C41.5886 19.5697 39.886 18.7814 38.0785 18.6956C37.187 16.7752 35.6968 15.1958 33.8314 14.1945C31.9661 13.1933 29.8263 12.8241 27.7334 13.1426C25.6404 13.461 23.7072 14.4498 22.224 15.9606C20.7408 17.4713 19.7875 19.4225 19.5074 21.5211H19.4244C17.9587 21.5201 16.5524 22.1009 15.5145 23.136C14.4766 24.1711 13.8918 25.5758 13.8887 27.0418Z"
        fill="url(#paint14_linear_7198_54573)"
      />
      <defs>
        <filter
          id="filter0_f_7198_54573"
          x="14.1142"
          y="100.114"
          width="113.772"
          height="55.7716"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_7198_54573"
          />
        </filter>
        <filter
          id="filter1_d_7198_54573"
          x="87.1914"
          y="0"
          width="62.5791"
          height="45.9922"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset
            dx="6"
            dy="4"
          />
          <feGaussianBlur stdDeviation="6.5" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7198_54573"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7198_54573"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_f_7198_54573"
          x="52.6053"
          y="71.8436"
          width="79.6879"
          height="47.6879"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood
            flood-opacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.422"
            result="effect1_foregroundBlur_7198_54573"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7198_54573"
          x1="74.8212"
          y1="-6.58124"
          x2="76.0452"
          y2="203.254"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stop-color="#EEEEFC"
            stop-opacity="0"
          />
          <stop
            offset="1"
            stop-color="#EBEBF8"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7198_54573"
          x1="31.4194"
          y1="88.1505"
          x2="124.5"
          y2="111.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop
            offset="1"
            stop-color="#E8E8F1"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7198_54573"
          x1="43.4009"
          y1="45.6951"
          x2="106.433"
          y2="45.6951"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5E7EB" />
          <stop
            offset="1"
            stop-color="#DDDAE0"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7198_54573"
          x1="43.4009"
          y1="62.7263"
          x2="106.433"
          y2="62.7263"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5E7EB" />
          <stop
            offset="1"
            stop-color="#DDDAE0"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_7198_54573"
          x1="43.4009"
          y1="79.7576"
          x2="106.433"
          y2="79.7576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5E7EB" />
          <stop
            offset="1"
            stop-color="#DDDAE0"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7198_54573"
          x1="43.4019"
          y1="96.7888"
          x2="106.434"
          y2="96.7888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E5E7EB" />
          <stop
            offset="1"
            stop-color="#DDDAE0"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_7198_54573"
          x1="13.9124"
          y1="108.818"
          x2="66.7657"
          y2="109.445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_7198_54573"
          x1="93.0931"
          y1="23.9915"
          x2="145.91"
          y2="25.5193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint8_linear_7198_54573"
          x1="19.9077"
          y1="95.101"
          x2="47.1086"
          y2="95.101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D1D2EE" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint9_linear_7198_54573"
          x1="20.1305"
          y1="113.943"
          x2="47.0976"
          y2="113.943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#989CA2" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint10_linear_7198_54573"
          x1="20.1305"
          y1="104.044"
          x2="47.0976"
          y2="104.044"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#989CA2" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint11_linear_7198_54573"
          x1="20.8398"
          y1="85.1741"
          x2="33.6079"
          y2="85.1741"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0B1F8" />
          <stop
            offset="1"
            stop-color="#E5E7EB"
          />
        </linearGradient>
        <linearGradient
          id="paint12_linear_7198_54573"
          x1="129.492"
          y1="73"
          x2="129.492"
          y2="98.9932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F2F3FC" />
          <stop
            offset="1"
            stop-color="#C6C9DF"
          />
        </linearGradient>
        <linearGradient
          id="paint13_linear_7198_54573"
          x1="20.4345"
          y1="94"
          x2="20.4345"
          y2="119.896"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F2F3FC" />
          <stop
            offset="1"
            stop-color="#C6C9DF"
          />
        </linearGradient>
        <linearGradient
          id="paint14_linear_7198_54573"
          x1="29.2902"
          y1="13.0312"
          x2="29.2902"
          y2="32.5743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F2F3FC" />
          <stop
            offset="1"
            stop-color="#C6C9DF"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
